import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useAdminStore, { PendingClient, AdminTeamMember } from '../store/adminStore';
import { auth, db, storage } from '../config/firebase'; 
import { doc, updateDoc, setDoc, getDoc, getDocs, collection, deleteDoc, addDoc, writeBatch, query, where, serverTimestamp, onSnapshot } from 'firebase/firestore'; 
import { adminUpdateMandantRoot, adminSetMandantRoot } from '../config/adminOverwriteGuard';
import { ref, deleteObject } from 'firebase/storage';
import KalkulationsdatenPage from './KalkulationsdatenPage';
import ProductivityDock from '../components/ProductivityDock';
import useAppStore from '../store/appStore'; 
import GlobalBackupManager from '../components/GlobalBackupManager';
import SentinelRadar from '../components/SentinelRadar';
import StripeRadar from '../components/StripeRadar';
import StealthSepaRadar from '../components/StealthSepaRadar';
import ChangeRadarBadge from '../components/changeRadar/ChangeRadarBadge';
import InvoiceCreatorModal from '../components/InvoiceCreatorModal'; 
import AdminNewsletterModal from '../components/AdminNewsletterModal';
import EventAdminModal from '../components/EventAdminModal';
import CoachingTerminePanel from '../components/admin/CoachingTerminePanel';
import CoachSeminarOverview from '../components/coach/CoachSeminarOverview';
import useEventStore, { shouldShowMissingTopicReminder } from '../store/eventStore';
import { IntakeHubModal } from './CoachIntakeAdminPage';
import {
  IntakeCountPill,
  IntakePendingAdoptionPill,
  useIntakeMenuCounts,
} from '../components/intake/IntakeMenuBadge';
import AktivCounterRadar from '../components/aktivcounter/AktivCounterRadar';
import { getAssignableTeam, resolveClientCoach, mergeTeamPool, clientMatchesMember } from '../utils/teamResolve';
import { resolveTeamMemberByEmail, isAdminPortalAccess } from '../utils/teamAuth';
import { activatePush, readPushStatus } from '../services/pushNotifications';
import { readForceSoloTarif, readPeoLetterFromMandantNr } from '../utils/soloMode';
import { Menu as MenuLucideIcon, X as XLucideIcon } from 'lucide-react';
import { PE_LOGO_SRC } from '../constants/brandAssets';
import { calculateClientMonthlyFee, formatMonthlyFeeDe, isNeukundenYearFromMandantNr, resolveTarifTier } from '../utils/clientPricing';
import { formatEuroDe, getCountryMwstSatz, netToGross } from '../utils/billingGross';
import { resolveStripeBillingBadge, STRIPE_PAYMENT_LOCK_ARMED } from '../utils/stripeBilling';
import {
    buildMandantNr,
    buildVorabMandantNr,
    extractCoreFromMandantNr,
    formatMandantNrDisplay,
    isValidMonthYearCore,
    isVorabOrLegacyMandantNr,
    migrateMandantNrIfNeeded,
    normalizeVorabMandantNr,
    parseMandantNr,
    resolveCoachInitialLetter,
    resolveTarifBadgeDisplay,
    resolveVertragsbeginnDisplay,
    tarifStatusFromTier,
} from '../utils/mandantNrFormat';
import { MandantNrPill } from '../components/MandantNrPill';

const DEFAULT_MANDANTEN_PARAMETER = {
    wochensatz: 4.33,
    auslastungsfaktor: 75,
    auslastungsfaktorMax: 100,
    zusatzumsatz: 30,
    gewinnlinie: 26,
    investlinie: 5,
    verlust1: 15,
    liquiditaet: 10
};

// 💉 HILFSFUNKTIONEN (Sicher auf oberster Ebene definiert, verhindert ts2304)
const parseParam = (val: any, fallback: number) => {
    if (val === undefined || val === null || val === '') return fallback;
    const parsed = parseFloat(val.toString().replace(',', '.'));
    return isNaN(parsed) ? fallback : parsed;
};

// 💉 AGGRESSIVER EXTRAKTOR: Löscht alles, was keine echte Mandantennummer ist
const extractCoreNumber = (nr: string) => extractCoreFromMandantNr(nr);

// --- ICONS ---
const IconBase = ({ children, size = 20, className = "" }: any) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{children}</svg>;
const LogOutIcon = (props: any) => <IconBase {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></IconBase>;
const ShieldAlertIcon = (props: any) => <IconBase {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></IconBase>;
const UsersIcon = (props: any) => <IconBase {...props}><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></IconBase>;
const SettingsIcon = (props: any) => <IconBase {...props}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1-2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></IconBase>;
const ExternalLinkIcon = (props: any) => <IconBase {...props}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></IconBase>;
const ShieldCheckIcon = (props: any) => <IconBase {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></IconBase>;
const BriefcaseIcon = (props: any) => <IconBase {...props}><rect width="20" height="14" x="2" y="7" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></IconBase>;
const LockIcon = (props: any) => <IconBase {...props}><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></IconBase>;
const KeyIcon = (props: any) => <IconBase {...props}><path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"/><path d="m21 2-9.6 9.6"/><circle cx="7.5" cy="15.5" r="5.5"/></IconBase>;
const AlertTriangleIcon = (props: any) => <IconBase {...props}><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></IconBase>;
const XIcon = (props: any) => <IconBase {...props}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></IconBase>;
const MailIcon = (props: any) => <IconBase {...props}><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></IconBase>;
const CheckCircleIcon = (props: any) => <IconBase {...props}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></IconBase>;
const ClockIcon = (props: any) => <IconBase {...props}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></IconBase>;
const MapPinIcon = (props: any) => <IconBase {...props}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></IconBase>;
const CalendarIcon = (props: any) => <IconBase {...props}><rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></IconBase>;
const ActivityIcon = (props: any) => <IconBase {...props}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></IconBase>;
const SearchIcon = (props: any) => <IconBase {...props}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></IconBase>;
const ArchiveIcon = (props: any) => <IconBase {...props}><polyline points="21 8 21 21 3 21 3 8"/><rect width="22" height="5" x="1" y="3" rx="1"/><line x1="10" y1="12" x2="14" y2="12"/></IconBase>;
const TrashIcon = (props: any) => <IconBase {...props}><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></IconBase>;
const HeartIcon = (props: any) => <IconBase {...props}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></IconBase>;
const PlusIcon = (props: any) => <IconBase {...props}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></IconBase>;
const BuildingIcon = (props: any) => <IconBase {...props}><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M8 10h.01"/><path d="M16 10h.01"/><path d="M8 14h.01"/><path d="M16 14h.01"/></IconBase>;
const FileTextIcon = (props: any) => <IconBase {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></IconBase>;
const RefreshIcon = (props: any) => <IconBase {...props}><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></IconBase>;
const ChevronDownIcon = (props: any) => <IconBase {...props}><polyline points="6 9 12 15 18 9"/></IconBase>;
const ChevronUpIcon = (props: any) => <IconBase {...props}><polyline points="18 15 12 9 6 15"/></IconBase>;
const LayersIcon = (props: any) => <IconBase {...props}><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 12 12 17 22 12"/><polyline points="2 17 12 22 22 17"/></IconBase>;

const AdminDashboard: React.FC = () => {
    const { 
        pendingApprovals, 
        crmClients,
        archivedClients,
        adminTeam,
        isLoadingPending, 
        error, 
        fetchClients, 
        startImpersonation,
        updateTeamMemberRole,
        assignCoachToClient,
        impersonatedClientId,
        syncAdminTeam,
    } = useAdminStore();
    
    const team = useAppStore(state => state.team || []);
    const teamRegistry = useAppStore(state => state.teamRegistry || []);
    const isInitialized = useAppStore(state => state.isInitialized);
    const authorizeTeamMember = useAppStore(state => state.authorizeTeamMember);
    const deauthorizeTeamMember = useAppStore(state => state.deauthorizeTeamMember);
    const settings = useAppStore(state => state.settings);

    const navigate = useNavigate();

    const portalRoleInfo = useMemo(
        () => resolveTeamMemberByEmail(auth.currentUser?.email, team, teamRegistry),
        [team, teamRegistry]
    );

    const canAccessAdminPortal = useMemo(
        () =>
            isAdminPortalAccess(
                portalRoleInfo.role,
                portalRoleInfo.category,
                auth.currentUser?.email
            ),
        [portalRoleInfo.role, portalRoleInfo.category]
    );

    useEffect(() => {
        if (!isInitialized) return;
        if (!canAccessAdminPortal) {
            if (!window.location.pathname.includes('/coach')) {
                navigate('/coach', { replace: true });
            }
        }
    }, [isInitialized, canAccessAdminPortal, navigate]);

    const refreshPushStatusUi = async () => {
        if (!canAccessAdminPortal) return;
        const uid = auth.currentUser?.uid;
        if (!uid) return;
        try {
            const st = await readPushStatus(uid);
            setPushLabel(st.label);
            setPushDetail(st.detail);
            setPushButtonText(st.buttonText);
            setPushActive(st.kind === 'active');
        } catch { /* silent */ }
    };

    useEffect(() => {
        if (!isInitialized || !canAccessAdminPortal) return;
        let cancelled = false;
        (async () => {
            const uid = auth.currentUser?.uid;
            if (!uid) return;
            try {
                const st = await readPushStatus(uid);
                if (cancelled) return;
                setPushLabel(st.label);
                setPushDetail(st.detail);
                setPushButtonText(st.buttonText);
                setPushActive(st.kind === 'active');
            } catch { /* silent */ }
        })();
        return () => { cancelled = true; };
    }, [isInitialized, canAccessAdminPortal]);

    const handleActivatePush = async () => {
        if (!canAccessAdminPortal || pushBusy) return;
        const uid = auth.currentUser?.uid;
        if (!uid) return;
        setPushBusy(true);
        try {
            const res = await activatePush(uid);
            setToast({ msg: res.message, type: res.ok ? 'success' : 'error' });
            await refreshPushStatusUi();
        } finally {
            setPushBusy(false);
        }
    };

    const [activeTab, setActiveTab] = useState<'freigabe' | 'crm' | 'archiv' | 'team' | 'parameter'>('crm');
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [showNewsletterModal, setShowNewsletterModal] = useState(false);
    const [showEventModal, setShowEventModal] = useState(false);
    const [showIntakeHub, setShowIntakeHub] = useState(false);
    const { openCount: openIntakeCount, pendingAdoptionCount } = useIntakeMenuCounts();
    /** Offene Seminar-Anmeldungen (status: neu) → Badge am Rechnungs-Creator */
    const [pendingSeminarRegsCount, setPendingSeminarRegsCount] = useState(0);
    const [toolsOpen, setToolsOpen] = useState(false);
    const [securityOpen, setSecurityOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Seminar-Anmeldungen im Puffer → Badge am Rechnungs-Creator
    useEffect(() => {
        const q = query(collection(db, 'seminar_anmeldungen'), where('status', '==', 'neu'));
        const unsub = onSnapshot(
            q,
            (snap) => {
                const count = snap.size;
                setPendingSeminarRegsCount(count);
                if (count > 0) setToolsOpen(true);
            },
            (err) => {
                console.warn('seminar_anmeldungen Listener:', err);
                setPendingSeminarRegsCount(0);
            }
        );
        return () => unsub();
    }, []);

    // Admin-Only Presence-Push (PEBase-Stack)
    const [pushLabel, setPushLabel] = useState('Push: Status unbekannt');
    const [pushDetail, setPushDetail] = useState('');
    const [pushButtonText, setPushButtonText] = useState('Lockscreen-Push aktivieren');
    const [pushBusy, setPushBusy] = useState(false);
    const [pushActive, setPushActive] = useState(false);
    
    const [searchTerm, setSearchTerm] = useState('');
    const [showOnlyMine, setShowOnlyMine] = useState(false);
    const [showInactive, setShowInactive] = useState(false);
    const [toast, setToast] = useState<{ msg: string, type: 'success' | 'error' } | null>(null);

    const [selectedAkte, setSelectedAkte] = useState<PendingClient | null>(null);
    const [drawerTab, setDrawerTab] = useState<'jahre' | 'stammdaten' | 'termine'>('jahre');
    const [drawerIsSaving, setDrawerIsSaving] = useState(false);
    const [stammdatenEdit, setStammdatenEdit] = useState<any>({});

    const [showEmergencyModal, setShowEmergencyModal] = useState(false);
    const [emergencyCode, setEmergencyCode] = useState('');
    const [emergencyError, setEmergencyError] = useState(false);
    const [isPromoting, setIsPromoting] = useState(false);

    const [showDeleteYearModal, setShowDeleteYearModal] = useState(false);
    const [yearToDelete, setYearToDelete] = useState<string | null>(null);
    const [deleteYearCode, setDeleteYearCode] = useState('');
    const [deleteYearError, setDeleteYearError] = useState(false);
    /** Pro-Akte: manuelles Geschäftsjahr setzen (nur diese Mandantenakte) */
    const [akteZielJahr, setAkteZielJahr] = useState<number>(2026);
    const [isSettingAkteJahr, setIsSettingAkteJahr] = useState(false);
    
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelClient, setCancelClient] = useState<PendingClient | null>(null);
    const [cancelMonth, setCancelMonth] = useState(''); 
    const [isProcessingAction, setIsProcessingAction] = useState(false);

    const [showVorabModal, setShowVorabModal] = useState(false);
    const [vorabData, setVorabData] = useState({
        vorname: '',
        nachname: '',
        salonname: '',
        mandantNr: '',
        betreuer: '',
        mailadresse: '',
        monatsbeitrag: '',
        zugangAb: '',
    });
    const [isSavingVorab, setIsSavingVorab] = useState(false);
    const [duplicateWarningOpen, setDuplicateWarningOpen] = useState(false);
    const [recruitCandidateId, setRecruitCandidateId] = useState('');
    const [isTeamActionSaving, setIsTeamActionSaving] = useState(false);

    const [showFilialModal, setShowFilialModal] = useState(false);
    const [filialDraft, setFilialDraft] = useState<Array<{ id: string; name: string; isMain: boolean; createdAt: string }>>([]);
    const [isSavingFilialen, setIsSavingFilialen] = useState(false);

    const autoArchiveRun = useRef(false);
    
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) fetchClients();
        });
        return () => unsubscribe();
    }, [fetchClients]);

    // Nach Firestore-Migrationen: CRM neu laden, sobald Tab wieder sichtbar ist
    useEffect(() => {
        const reload = () => {
            if (document.visibilityState === 'visible' && auth.currentUser) {
                fetchClients();
            }
        };
        document.addEventListener('visibilitychange', reload);
        window.addEventListener('focus', reload);
        return () => {
            document.removeEventListener('visibilitychange', reload);
            window.removeEventListener('focus', reload);
        };
    }, [fetchClients]);

    useEffect(() => {
        syncAdminTeam();
    }, [team, syncAdminTeam]);

    // Themen-Reminder + Seminare (wie CoachDashboard)
    const eventList = useEventStore((s) => s.events);
    const fetchEvents = useEventStore((s) => s.fetchEvents);
    useEffect(() => {
        if (!canAccessAdminPortal) return;
        void fetchEvents();
    }, [canAccessAdminPortal, fetchEvents]);
    const showMissingTopicReminder =
        canAccessAdminPortal && eventList.some((ev) => shouldShowMissingTopicReminder(ev));

    // 💉 VERDECKTER DIAGNOSE-SCAN (JEAN-DUBLETTE): Nur Superadmin, nur Konsole, keine UI.
    const jeanScanRun = useRef(false);
    useEffect(() => {
        if (jeanScanRun.current) return;
        if (auth.currentUser?.email?.toLowerCase() !== 'erfolg@friseur-coaching.de') return;
        if ((team.length === 0 && teamRegistry.length === 0)) return;
        jeanScanRun.current = true;

        const runJeanDiagnostics = async () => {
            const NEEDLE = 'jean';
            const matchesJean = (entry: any) => {
                const email = String(entry?.email || '').toLowerCase();
                const name = String(entry?.name || '').toLowerCase();
                return email.includes(NEEDLE) || name.includes(NEEDLE);
            };

            console.log('%c🔍 JEAN-DUBLETTEN-SCAN GESTARTET', 'color:#E6C299;font-weight:bold;');

            // 1. Team-Pool (team + teamRegistry) auf Jean-Einträge scannen
            const teamHits = (team || []).filter(matchesJean);
            const registryHits = (teamRegistry || []).filter(matchesJean);

            console.log(`🔍 [TEAM] ${teamHits.length} Treffer im 'team'-Array:`);
            teamHits.forEach((m: any) => console.log('   →', { name: m.name, email: m.email, id: m.id, role: m.role, category: m.category }));

            console.log(`🔍 [REGISTRY] ${registryHits.length} Treffer in 'teamRegistry':`);
            registryHits.forEach((m: any) => console.log('   →', { name: m.name, email: m.email, id: m.id, role: m.role, category: m.category }));

            const allIds = [...teamHits, ...registryHits].map((m: any) => String(m.id));
            const uniqueIds = Array.from(new Set(allIds));
            if (uniqueIds.length > 1) {
                console.warn(`⚠️ [DUBLETTE BESTÄTIGT] Jean existiert mit ${uniqueIds.length} unterschiedlichen IDs im Team-Pool:`, uniqueIds);
            } else if (uniqueIds.length === 1) {
                console.log(`✅ [TEAM-POOL SAUBER] Nur eine Jean-ID im Pool: ${uniqueIds[0]}`);
            } else {
                console.warn('⚠️ [KEIN TREFFER] Kein Jean-Eintrag im Team-Pool gefunden.');
            }

            // 2. Mandanten-Collection auf Jean-Dokumente scannen
            try {
                const snapshot = await getDocs(collection(db, 'kalkulation_mandanten'));
                const mandantHits: any[] = [];
                snapshot.forEach((docSnap) => {
                    const data = docSnap.data();
                    const cd = data.clientData || {};
                    const haystack = [
                        data.email, data.mailadresse, cd.email, cd.mailadresse,
                        data.name, data.vorname, data.nachname, cd.name, cd.vorname, cd.nachname,
                        data.unternehmername, cd.unternehmername,
                    ].map((v) => String(v || '').toLowerCase()).join(' | ');
                    if (haystack.includes(NEEDLE)) {
                        mandantHits.push({
                            docId: docSnap.id,
                            email: data.email || cd.email || cd.mailadresse || '---',
                            name: cd.name || `${cd.vorname || ''} ${cd.nachname || ''}`.trim() || data.name || '---',
                            mandantNr: data.mandantNr || cd.mandantNr || '---',
                            betreuer: data.betreuer || cd.betreuer || '---',
                            isArchived: !!data.isArchived,
                        });
                    }
                });
                console.log(`🔍 [MANDANTEN] ${mandantHits.length} Jean-verdächtige Dokumente in 'kalkulation_mandanten':`);
                mandantHits.forEach((h) => console.log('   →', h));
                if (mandantHits.length > 0) {
                    console.warn('⚠️ [ZOMBIE-VERDACHT] Diese Dokument-IDs prüfen – ggf. Reste der alten Mandanten-Registrierung.');
                }
            } catch (err) {
                console.warn('🔍 [MANDANTEN] Scan fehlgeschlagen:', err);
            }

            console.log('%c🔍 JEAN-DUBLETTEN-SCAN ABGESCHLOSSEN', 'color:#E6C299;font-weight:bold;');
        };

        runJeanDiagnostics();
    }, [team, teamRegistry]);

    useEffect(() => {
        if (!autoArchiveRun.current && (crmClients.length > 0 || pendingApprovals.length > 0)) {
            autoArchiveRun.current = true;
            let needsRefetch = false;
            const now = new Date();
            const allActive = [...pendingApprovals, ...crmClients].filter(c => !c.isArchived && c.kuendigungsDatum && !(c as any).isDeleted);
            
            Promise.all(allActive.map(async (client) => {
                if (new Date(client.kuendigungsDatum) < now) {
                    try {
                        await adminUpdateMandantRoot(client.id, { isArchived: true });
                        needsRefetch = true;
                    } catch (e) { console.error("Wachhund-Fehler:", e); }
                }
            })).then(() => {
                if (needsRefetch) fetchClients();
            });
        }
    }, [crmClients, pendingApprovals, fetchClients]);

    const handleLogout = () => auth.signOut();

    const isSuperAdminOperator = useMemo(() => {
        const email = auth.currentUser?.email?.toLowerCase() || '';
        if (email === 'erfolg@friseur-coaching.de') return true;
        return resolveTeamMemberByEmail(auth.currentUser?.email, team).role === 'superadmin';
    }, [team]);

    const persistTeamStateToFirebase = async () => {
        const { team: activeTeam, teamRegistry: registry } = useAppStore.getState();
        const sysRef = doc(db, 'system_data', 'global_settings');
        await updateDoc(sysRef, { team: activeTeam, teamRegistry: registry });
        syncAdminTeam();
    };

    const handleAuthorizeTeamMember = async () => {
        if (!recruitCandidateId || !isSuperAdminOperator) return;
        setIsTeamActionSaving(true);
        try {
            authorizeTeamMember(recruitCandidateId);
            await persistTeamStateToFirebase();
            const authorized = (teamRegistry || []).find(m => m.id === recruitCandidateId);
            showNotification(`${authorized?.name || recruitCandidateId} autorisiert.`, 'success');
            setRecruitCandidateId('');
        } catch (err) {
            console.error(err);
            showNotification('Fehler beim Autorisieren.', 'error');
        } finally {
            setIsTeamActionSaving(false);
        }
    };

    const handleDeauthorizeTeamMember = async (memberId: string) => {
        if (!memberId || !isSuperAdminOperator) return;
        const member = team.find(m => m.id === memberId);
        if (!member) return;
        if (!window.confirm(`"${member.name}" aus dem aktiven Team entfernen? (Bleibt in der Registry)`)) return;
        setIsTeamActionSaving(true);
        try {
            deauthorizeTeamMember(memberId);
            await persistTeamStateToFirebase();
            showNotification(`${member.name} aus aktivem Team entfernt.`, 'success');
        } catch (err) {
            console.error(err);
            showNotification('Fehler beim Entfernen.', 'error');
        } finally {
            setIsTeamActionSaving(false);
        }
    };

    const showNotification = (msg: string, type: 'success' | 'error') => {
        setToast({ msg, type });
        setTimeout(() => setToast(null), 4000); 
    };

    const getGlobalPriceFromEdit = (edit: any) => {
        if (!settings?.global || !edit?.lizenzTyp || edit.isLegacy) return '';
        const isSolo = !!edit.isSolo;
        const hasEmployeeEval = !!edit.hasEmployeeEval;
        const neukundenAn = !!edit.neukundenAufschlag;
        const forceSoloTarif = !!edit.forceSoloTarif;
        const fee = calculateClientMonthlyFee({
            settings,
            lizenzTyp: edit.lizenzTyp,
            client: {
                ...(selectedAkte || {}),
                isSolo,
                hasEmployeeEval,
                isBestandskunde: !neukundenAn,
                forceSoloTarif,
                forceNewCustomerPremium: neukundenAn,
                disableNewCustomerPremium: !neukundenAn,
                neukundenManualOverride: !!edit.neukundenManualOverride,
            },
            forceSoloTarif,
            isSolo,
            hasEmployeeEval,
            isNewCustomer: neukundenAn,
            forceNewCustomerPremium: neukundenAn,
            disableNewCustomerPremium: !neukundenAn,
            neukundenManualOverride: !!edit.neukundenManualOverride,
            mandantNr: edit.coreMandantNr || selectedAkte?.mandantNr || selectedAkte?.clientData?.mandantNr,
            isProBono: false,
        });
        return formatMonthlyFeeDe(fee);
    };

    const applyFeeToEdit = (nextEdit: any) => {
        let monthlyFee = nextEdit.monthlyFee;
        if (!nextEdit.isLegacy && nextEdit.lizenzTyp && settings?.global) {
            const priced = getGlobalPriceFromEdit(nextEdit);
            if (priced !== '') monthlyFee = priced;
        }
        return { ...nextEdit, monthlyFee };
    };

    /** Ein Häkchen: Nummer steuert auto; manueller Override nur wenn bewusst anders. */
    const applyNeukundenToEdit = (edit: any, neukundenAn: boolean, manualOverride: boolean) =>
        applyFeeToEdit({
            ...edit,
            neukundenAufschlag: neukundenAn,
            neukundenManualOverride: manualOverride,
            forceNewCustomerPremium: neukundenAn,
            disableNewCustomerPremium: !neukundenAn,
            isBestandskunde: !neukundenAn,
            isPremium2027: neukundenAn,
        });

    const syncNeukundenFromNummer = (edit: any) => {
        const fromNr = isNeukundenYearFromMandantNr(edit.coreMandantNr || edit.vertragsbeginn || '');
        // Nummer-Wechsel = wieder Auto-Modus (kein klebriger Override)
        return applyNeukundenToEdit(edit, fromNr, false);
    };

    const handleNeukundenToggle = (checked: boolean) => {
        const auto = isNeukundenYearFromMandantNr(
            stammdatenEdit.coreMandantNr || stammdatenEdit.vertragsbeginn || ''
        );
        // Nur Override speichern, wenn Admin bewusst gegen die Nummer stellt
        setStammdatenEdit(applyNeukundenToEdit(stammdatenEdit, checked, checked !== auto));
    };

    const resolveEditTarif = (): 'solo' | 'team' | 'team_base' => {
        if (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo) return 'solo';
        if (stammdatenEdit.hasEmployeeEval === true) return 'team';
        return 'team_base';
    };

    /** Ein Tarif-Schalter: Solo | Team (Team-Plus entsteht automatisch über den Umsatz; TeamBase bleibt nur für Altbestand lesbar). */
    const handleTarifSelect = (tarif: 'solo' | 'team') => {
        if (tarif === 'solo') {
            setStammdatenEdit(applyFeeToEdit({
                ...stammdatenEdit,
                isSolo: true,
                forceSoloTarif: true,
                hasEmployeeEval: false,
                insiderTeamleaderPlusChecked: false,
                insiderTeamleaderStandardChecked: false,
                lizenzTyp: 'insider',
            }));
            return;
        }
        setStammdatenEdit(applyFeeToEdit({
            ...stammdatenEdit,
            isSolo: false,
            forceSoloTarif: false,
            hasEmployeeEval: true,
            insiderTeamleaderStandardChecked: true,
            lizenzTyp: 'insider',
        }));
    };

    const checkForDuplicate = () => {
        const allClients = [...crmClients, ...pendingApprovals];
        return allClients.some(c => {
            const matchNr = vorabData.mandantNr && c.mandantNr && c.mandantNr.toLowerCase().trim() === vorabData.mandantNr.toLowerCase().trim();
            const salonA = c.firmenname || c.clientData?.salonname || '';
            const matchName = vorabData.salonname && salonA && salonA.toLowerCase().trim() === vorabData.salonname.toLowerCase().trim();
            return matchNr || matchName;
        });
    };

    const handleSaveVorabkunde = async (forceOverride = false) => {
        if (!vorabData.salonname || !vorabData.mandantNr) {
            showNotification("Firma und Mandant-Nummer sind Pflichtfelder!", "error");
            return;
        }
        if (!vorabData.zugangAb || !/^\d{4}-\d{2}$/.test(vorabData.zugangAb)) {
            showNotification("Bitte den Zugangsmonat angeben (Zugang ab).", "error");
            return;
        }

        if (forceOverride !== true) {
            const isDup = checkForDuplicate();
            if (isDup) {
                setDuplicateWarningOpen(true);
                return;
            }
        }

        setIsSavingVorab(true);
        try {
            let parsedFee = 0;
            if (vorabData.monatsbeitrag) {
                const parsed = parseFloat(vorabData.monatsbeitrag.replace(',', '.'));
                if (!isNaN(parsed)) parsedFee = parsed;
            }

            let vertragsbeginn: string | null = null;
            if (vorabData.zugangAb && /^\d{4}-\d{2}$/.test(vorabData.zugangAb)) {
                const [y, m] = vorabData.zugangAb.split('-');
                vertragsbeginn = `${m}/${y}`;
            }

            const coachInitial = resolveCoachInitialLetter(
                assignableTeam.find((c) => c.id === vorabData.betreuer)?.name || vorabData.betreuer,
                assignableTeam
            );
            // Eingabe darf "22/2022" oder Altformat sein → immer `MA NN/YYYY-X`
            const cleanVorabNr =
                normalizeVorabMandantNr(vorabData.mandantNr, coachInitial) ||
                buildVorabMandantNr(extractCoreNumber(vorabData.mandantNr) || vorabData.mandantNr, coachInitial);

            if (!cleanVorabNr) {
                showNotification("Mandant-Nummer ungültig — erwartet z. B. 22/2022.", "error");
                setIsSavingVorab(false);
                return;
            }

            const clientPayload = {
                firmenname: vorabData.salonname,
                vorname: vorabData.vorname,
                nachname: vorabData.nachname,
                email: vorabData.mailadresse,
                mailadresse: vorabData.mailadresse,
                mandantNr: cleanVorabNr,
                customerNumber: cleanVorabNr,
                existingCustomerNumber: cleanVorabNr,
                betreuer: vorabData.betreuer,
                coachId: vorabData.betreuer, 
                monthlyFee: parsedFee,
                status: 'aktiv',
                isArchived: false,
                isLegacy: true,
                isExistingCustomer: true,
                isBestandskunde: true,
                isSolo: false,
                forceSoloTarif: false,
                createdAt: new Date().toISOString(),
                vertragsbeginn,
                clientData: {
                    salonname: vorabData.salonname,
                    vorname: vorabData.vorname,
                    nachname: vorabData.nachname,
                    mailadresse: vorabData.mailadresse,
                    email: vorabData.mailadresse,
                    mandantNr: cleanVorabNr,
                    customerNumber: cleanVorabNr,
                    existingCustomerNumber: cleanVorabNr,
                    betreuer: vorabData.betreuer,
                    coachId: vorabData.betreuer,
                    monthlyFee: parsedFee,
                    vertragsbeginn,
                    isSolo: false,
                    forceSoloTarif: false,
                    contact: {
                        firstName: vorabData.vorname,
                        lastName: vorabData.nachname
                    },
                    ...DEFAULT_MANDANTEN_PARAMETER
                }
            };

            await addDoc(collection(db, 'kalkulation_mandanten'), {
                ...clientPayload,
                lastAdminUpdate: serverTimestamp(),
            });
            showNotification("Vorabkunde erfolgreich angelegt!", "success");
            setShowVorabModal(false);
            setDuplicateWarningOpen(false);
            setVorabData({
                vorname: '',
                nachname: '',
                salonname: '',
                mandantNr: '',
                betreuer: '',
                mailadresse: '',
                monatsbeitrag: '',
                zugangAb: '',
            });
            fetchClients();
        } catch (e) {
            console.error(e);
            showNotification("Fehler beim Erstellen des Vorabkunden.", "error");
        } finally {
            setIsSavingVorab(false);
        }
    };

    const handleJSONImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file || !selectedAkte) return;

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const jsonString = event.target?.result as string;
                let parsedData;
                try {
                    parsedData = JSON.parse(jsonString);
                } catch (parseErr) {
                    showNotification("Import fehlgeschlagen: Datei ist kein gültiges JSON.", "error");
                    if (fileInputRef.current) fileInputRef.current.value = '';
                    return;
                }

                const newParams = {
                    wochensatz: parseParam(parsedData.wochensatz, DEFAULT_MANDANTEN_PARAMETER.wochensatz),
                    auslastungsfaktor: parseParam(parsedData.auslastungsfaktor, DEFAULT_MANDANTEN_PARAMETER.auslastungsfaktor),
                    auslastungsfaktorMax: parseParam(parsedData.auslastungsfaktorMax, DEFAULT_MANDANTEN_PARAMETER.auslastungsfaktorMax),
                    zusatzumsatz: parseParam(parsedData.zusatzumsatz, DEFAULT_MANDANTEN_PARAMETER.zusatzumsatz),
                    gewinnlinie: parseParam(parsedData.gewinnlinie, DEFAULT_MANDANTEN_PARAMETER.gewinnlinie),
                    investlinie: parseParam(parsedData.investlinie, DEFAULT_MANDANTEN_PARAMETER.investlinie),
                    verlust1: parseParam(parsedData.verlust1, DEFAULT_MANDANTEN_PARAMETER.verlust1),
                    liquiditaet: parseParam(parsedData.liquiditaet, DEFAULT_MANDANTEN_PARAMETER.liquiditaet)
                };

                setStammdatenEdit((prev: any) => ({ ...prev, ...newParams }));

                const docRefUid = selectedAkte.id;
                await adminUpdateMandantRoot(docRefUid, {
                    'clientData.wochensatz': newParams.wochensatz,
                    'clientData.auslastungsfaktor': newParams.auslastungsfaktor,
                    'clientData.auslastungsfaktorMax': newParams.auslastungsfaktorMax,
                    'clientData.zusatzumsatz': newParams.zusatzumsatz,
                    'clientData.gewinnlinie': newParams.gewinnlinie,
                    'clientData.investlinie': newParams.investlinie,
                    'clientData.verlust1': newParams.verlust1,
                    'clientData.liquiditaet': newParams.liquiditaet
                });

                showNotification("Parameter erfolgreich geladen!", "success");
                if (fileInputRef.current) fileInputRef.current.value = '';
            } catch (err: any) {
                showNotification(`Datenbank-Fehler: ${err.message}`, "error");
                if (fileInputRef.current) fileInputRef.current.value = '';
            }
        };
        reader.onerror = () => showNotification("Lokaler Dateilesefehler.", "error");
        reader.readAsText(file);
    };

    const handleArchive = async (id: string) => {
        setIsProcessingAction(true);
        try {
            await adminUpdateMandantRoot(id, { isArchived: true });
            showNotification("Akte erfolgreich ins Archiv verschoben.", "success");
            fetchClients();
        } catch (e) {
            showNotification("Fehler beim Archivieren.", "error");
        } finally { setIsProcessingAction(false); }
    };

    const handleReactivate = async (id: string) => {
        setIsProcessingAction(true);
        try {
            // Vollständige Reaktivierung: Archiv-Flag + Soft-Delete/Active + Freigabe,
            // sonst landet der Mandant wieder auf „Akte übergeben!“ / verschwindet aus CRM.
            await adminUpdateMandantRoot(id, {
                isArchived: false,
                kuendigungsDatum: null,
                isDeleted: false,
                isActive: true,
                isUnlockedByAdmin: true,
                'clientData.isUnlockedByAdmin': true,
            });
            showNotification("Mandant erfolgreich reaktiviert und freigeschaltet.", "success");
            fetchClients();
        } catch (e) {
            showNotification("Fehler bei der Reaktivierung.", "error");
        } finally { setIsProcessingAction(false); }
    };

    const handleHardDelete = async (id: string, name: string) => {
        const input = window.prompt(`WARNUNG: Soft-Delete für ${name}!\n\nDie Akte wird komplett aus dem System ausgeblendet. Physisch bleiben die Daten als Sicherheitsnetz erhalten.\n\nBitte "LÖSCHEN" exakt so eintippen zur Bestätigung:`);
        if (input === 'LÖSCHEN') {
            setIsProcessingAction(true);
            try {
                await adminUpdateMandantRoot(id, { isDeleted: true, isActive: false });
                showNotification("Akte erfolgreich aus dem System ausgeblendet.", "success");
                fetchClients();
            } catch (e) {
                showNotification("Fehler beim Ausführen der Löschung.", "error");
            } finally { setIsProcessingAction(false); }
        } else if (input !== null) {
            showNotification("Vorgang abgebrochen. Falscher Autorisierungscode.", "error");
        }
    };

    // Akte zurück ins Freigabe-Center (Flags reset + Betreuer-Zuordnung leeren)
    const handleResetAkteToFreigabe = async () => {
        if (!selectedAkte?.id) return;
        if (!canAccessAdminPortal) {
            showNotification("Zugriff verweigert.", "error");
            return;
        }
        if (!window.confirm(`Akte „${selectedAkte.firmenname || selectedAkte.vorname || selectedAkte.id}" wirklich ins Freigabe-Center zurücksetzen?\n\nBetreuer-Zuordnung wird geleert.`)) {
            return;
        }
        setIsProcessingAction(true);
        try {
            await adminUpdateMandantRoot(selectedAkte.id, {
                isArchived: false,
                isDeleted: false,
                isActive: true,
                isUnlockedByAdmin: false,
                isReadyForReview: true,
                onboardingStatus: 'submitted',
                betreuer: '',
                coachId: '',
                coach: '',
                'clientData.betreuer': '',
                'clientData.coachId': '',
                'clientData.coach': '',
            });
            window.alert("Akte repariert und ins Freigabe-Center verschoben!");
            setSelectedAkte(null);
            fetchClients();
        } catch (e) {
            console.error("Akte-Reset fehlgeschlagen:", e);
            showNotification("Fehler beim Zurücksetzen der Akte.", "error");
        } finally {
            setIsProcessingAction(false);
        }
    };

    // Nur Dashboard freischalten (ohne Stammdaten-Save) — gegen „Akte übergeben!“-Kleben
    const handleForceUnlockDashboard = async () => {
        if (!selectedAkte?.id) return;
        if (!canAccessAdminPortal) {
            showNotification("Zugriff verweigert.", "error");
            return;
        }
        setIsProcessingAction(true);
        try {
            await adminUpdateMandantRoot(selectedAkte.id, {
                isArchived: false,
                isDeleted: false,
                isActive: true,
                isUnlockedByAdmin: true,
                onboardingStatus: 'submitted',
                'clientData.isUnlockedByAdmin': true,
            });
            setSelectedAkte({ ...selectedAkte, isUnlockedByAdmin: true });
            showNotification("Dashboard freigeschaltet. Mandant neu laden / einloggen lassen.", "success");
            fetchClients();
        } catch (e) {
            console.error("Freischalten fehlgeschlagen:", e);
            showNotification("Freischalten fehlgeschlagen.", "error");
        } finally {
            setIsProcessingAction(false);
        }
    };

    const handleResetMasterPinLock = async () => {
        if (!selectedAkte?.id) return;
        if (!canAccessAdminPortal) {
            showNotification("Zugriff verweigert.", "error");
            return;
        }
        if (!window.confirm(
            `Master-PIN & Seitensperren für „${selectedAkte.firmenname || selectedAkte.vorname || selectedAkte.id}" wirklich zurücksetzen?\n\nPIN und alle gesperrten Seiten werden auf Werkseinstellung geleert.`
        )) {
            return;
        }
        setIsProcessingAction(true);
        try {
            const resetCfg = { isPinActive: false, pinHash: '', lockedPageIds: [] as string[] };
            await adminUpdateMandantRoot(selectedAkte.id, {
                pinLockConfig: resetCfg,
                'clientData.pinLockConfig': resetCfg,
            });
            showNotification("Master-PIN & Sperren zurückgesetzt.", "success");
            fetchClients();
        } catch (e) {
            console.error("Master-PIN-Reset fehlgeschlagen:", e);
            showNotification("Master-PIN-Reset fehlgeschlagen.", "error");
        } finally {
            setIsProcessingAction(false);
        }
    };

    // ☢️ HARD-PURGE (Superadmin-Only): Löscht Mandanten-Akte + ALLE Kollateral-Referenzen ENDGÜLTIG.
    // Nicht verwechseln mit handleHardDelete (das bleibt ein Soft-Delete).
    const forcePurgeUserFiles = async (emailOrUid: string) => {
        if (auth.currentUser?.email?.toLowerCase() !== 'erfolg@friseur-coaching.de') {
            showNotification("Zugriff verweigert: Nur Superadmin.", "error");
            return;
        }

        const needle = String(emailOrUid || '').trim().toLowerCase();
        if (!needle) {
            showNotification("Bitte E-Mail oder UID eingeben.", "error");
            return;
        }

        const confirmed = window.confirm(
            `☢️ HARD-PURGE WARNUNG ☢️\n\nZiel: "${needle}"\n\nFolgende Daten werden ENDGÜLTIG und UNWIEDERBRINGLICH gelöscht:\n• Mandanten-Akte (inkl. aller Jahres-Dokumente)\n• Manuelle Rechnungen (coach_manual_invoices)\n• PE-Papers Dokumente\n• Seminar-Anmeldungen\n\nEs gibt KEIN Backup und KEIN Zurück.\n\nWirklich fortfahren?`
        );
        if (!confirmed) return;

        try {
            const norm = (v: any) => String(v || '').trim().toLowerCase();

            // 1. Mandanten-Treffer suchen (normalisierter Abgleich über doc.id, email, clientData.email, clientData.mailadresse)
            const mandantenSnap = await getDocs(collection(db, 'kalkulation_mandanten'));
            const hits: { id: string; emails: string[] }[] = [];
            mandantenSnap.forEach((docSnap) => {
                const data: any = docSnap.data();
                const cd = data?.clientData || {};
                const candidates = [docSnap.id, data?.email, cd?.email, cd?.mailadresse].map(norm);
                if (candidates.includes(needle)) {
                    const emails = Array.from(new Set(
                        [data?.email, cd?.email, cd?.mailadresse].map(norm).filter(e => e && e.includes('@'))
                    ));
                    hits.push({ id: docSnap.id, emails });
                }
            });

            if (hits.length === 0) {
                showNotification(`Kein Mandant für "${needle}" gefunden. Nichts gelöscht.`, "error");
                return;
            }

            // Alle bekannten Ziel-E-Mails sammeln (inkl. der Eingabe selbst, falls E-Mail)
            const targetEmails = new Set<string>(hits.flatMap(h => h.emails));
            if (needle.includes('@')) targetEmails.add(needle);
            const targetIds = new Set<string>(hits.map(h => h.id));

            // Batch-Verwaltung: writeBatch in Chunks von max. 500 Operationen
            const deletedLog: Record<string, string[]> = {
                'kalkulation_mandanten (Root)': [],
                'kalkulation_mandanten/jahre': [],
                'coach_manual_invoices': [],
                'pepapers_documents': [],
                'seminar_anmeldungen': []
            };
            let batch = writeBatch(db);
            let opCount = 0;
            const committedBatches: Promise<void>[] = [];
            const addDelete = (ref: any, logKey: string, logId: string) => {
                batch.delete(ref);
                deletedLog[logKey].push(logId);
                opCount++;
                if (opCount >= 500) {
                    committedBatches.push(batch.commit());
                    batch = writeBatch(db);
                    opCount = 0;
                }
            };

            for (const hit of hits) {
                // 2. Subcollection 'jahre' zuerst löschen
                const jahreSnap = await getDocs(collection(db, 'kalkulation_mandanten', hit.id, 'jahre'));
                jahreSnap.forEach((j) => addDelete(j.ref, 'kalkulation_mandanten/jahre', `${hit.id}/jahre/${j.id}`));

                // 3. Root-Dokument endgültig löschen
                addDelete(doc(db, 'kalkulation_mandanten', hit.id), 'kalkulation_mandanten (Root)', hit.id);

                // 4. coach_manual_invoices mit clientId == Mandanten-ID
                const invSnap = await getDocs(query(collection(db, 'coach_manual_invoices'), where('clientId', '==', hit.id)));
                invSnap.forEach((d) => addDelete(d.ref, 'coach_manual_invoices', d.id));

                // 5. pepapers_documents mit userId == UID des Mandanten
                const papersSnap = await getDocs(query(collection(db, 'pepapers_documents'), where('userId', '==', hit.id)));
                papersSnap.forEach((d) => addDelete(d.ref, 'pepapers_documents', d.id));
            }

            // 6. seminar_anmeldungen: E-Mail-Abgleich (normalisiert, da E-Mails verschachtelt in formData liegen können)
            if (targetEmails.size > 0) {
                const semSnap = await getDocs(collection(db, 'seminar_anmeldungen'));
                semSnap.forEach((d) => {
                    const data: any = d.data();
                    const semEmail = norm(data?.formData?.email || data?.email);
                    if (semEmail && targetEmails.has(semEmail)) {
                        addDelete(d.ref, 'seminar_anmeldungen', d.id);
                    }
                });
            }

            // Letzten (Teil-)Batch committen und auf alle warten
            if (opCount > 0) committedBatches.push(batch.commit());
            await Promise.all(committedBatches);

            // 7. Zusammenfassung
            const totalDeleted = Object.values(deletedLog).reduce((sum, arr) => sum + arr.length, 0);
            console.log("☢️ HARD-PURGE ABGESCHLOSSEN. Gelöschte Dokument-IDs:", deletedLog);
            const summaryLines = Object.entries(deletedLog)
                .map(([key, ids]) => `• ${key}: ${ids.length}`)
                .join('\n');
            window.alert(`☢️ HARD-PURGE ERFOLGREICH\n\nZiel: ${Array.from(targetIds).join(', ')}\n\nGelöschte Dokumente (${totalDeleted} gesamt):\n${summaryLines}\n\nAlle gelöschten Dokument-IDs stehen in der Konsole (F12).`);
            showNotification(`Hard-Purge abgeschlossen: ${totalDeleted} Dokument(e) endgültig gelöscht.`, "success");
            fetchClients();
        } catch (err: any) {
            console.error("❌ HARD-PURGE FEHLGESCHLAGEN:", err);
            showNotification(`Hard-Purge fehlgeschlagen: ${err?.message || 'Unbekannter Fehler'}`, "error");
        }
    };

    useEffect(() => {
        // Superadmin-Notfall ohne UI-Button: Konsole → __forcePurgeUserFiles('email-oder-uid')
        (window as any).__forcePurgeUserFiles = forcePurgeUserFiles;
        return () => {
            if ((window as any).__forcePurgeUserFiles === forcePurgeUserFiles) {
                delete (window as any).__forcePurgeUserFiles;
            }
        };
    });

    const handleDeleteYear = async () => {
        if (!selectedAkte || !yearToDelete) return;
        setIsProcessingAction(true);
        try {
            try {
                const fileRef = ref(storage, `kalkulation_mandanten/${selectedAkte.id}/uploads/BWA_${yearToDelete}.pdf`);
                await deleteObject(fileRef);
            } catch (err: any) { console.warn("PDF konnte nicht gelöscht werden"); }

            const updatedYears = (selectedAkte.geschaeftsjahre || []).filter((y: any) => y.jahr.toString() !== yearToDelete.toString());
            await adminUpdateMandantRoot(selectedAkte.id, {
                geschaeftsjahre: updatedYears,
                'clientData.geschaeftsjahre': updatedYears,
            });
            await deleteDoc(doc(db, 'kalkulation_mandanten', selectedAkte.id, 'jahre', yearToDelete.toString()));

            setSelectedAkte({ ...selectedAkte, geschaeftsjahre: updatedYears });
            fetchClients();
            
            showNotification(`Jahr ${yearToDelete} (inkl. PDF) wurde restlos gelöscht.`, "success");
            setShowDeleteYearModal(false);
            setYearToDelete(null);
            setDeleteYearCode('');
            setDeleteYearError(false);
        } catch (e) {
            showNotification("Fehler beim Löschen des Jahres.", "error");
        } finally {
            setIsProcessingAction(false);
        }
    };

    /** Nur diese Akte: Geschäftsjahr setzen / umbenennen (z.B. 2027 → 2026). Kein System-Global. */
    const handleSetAkteGeschaeftsjahr = async () => {
        if (!selectedAkte?.id) return;
        const targetYear = Number(akteZielJahr);
        if (!Number.isFinite(targetYear) || targetYear < 2000 || targetYear > 2100) {
            showNotification('Ungültiges Zieljahr.', 'error');
            return;
        }

        const existing = selectedAkte.geschaeftsjahre || [];
        const alreadyHas = existing.some((j: any) => Number(j.jahr) === targetYear);
        const onlyOne = existing.length === 1;
        const oldYear = onlyOne ? Number(existing[0]?.jahr) : null;

        const confirmMsg = alreadyHas
            ? `Akte bereits auf ${targetYear}. Als aktives Jahr setzen und Login-Kontext aktualisieren?`
            : onlyOne && oldYear && oldYear !== targetYear
                ? `Geschäftsjahr dieser Akte von ${oldYear} auf ${targetYear} umbenennen?\n\n(Nur diese Mandantenakte — Kalkulationsdaten bleiben erhalten.)`
                : `ACHTUNG: Jahr ${targetYear} existiert noch NICHT.\n\n` +
                  `Das legt ein NEUES Geschäftsjahr an (wie „Neues Jahr starten“ auf dem Dashboard).\n` +
                  `Stammdaten speichern darf das NICHT stillschweigend tun.\n\n` +
                  `Wirklich ${targetYear} neu anlegen und aktiv setzen?`;

        if (!window.confirm(confirmMsg)) return;

        setIsSettingAkteJahr(true);
        try {
            const mandantRef = doc(db, 'kalkulation_mandanten', selectedAkte.id);
            const freshSnap = await getDoc(mandantRef);
            const freshData = freshSnap.exists() ? freshSnap.data() : {};
            const rootYears: any[] = Array.isArray(freshData.geschaeftsjahre)
                ? freshData.geschaeftsjahre
                : (Array.isArray(freshData.clientData?.geschaeftsjahre) ? freshData.clientData.geschaeftsjahre : []);

            let updatedJahre: any[] = [...rootYears];
            let renamedFrom: number | null = null;

            const hasTarget = updatedJahre.some((j: any) => Number(j.jahr) === targetYear);

            if (!hasTarget && updatedJahre.length === 1 && Number(updatedJahre[0]?.jahr) !== targetYear) {
                renamedFrom = Number(updatedJahre[0].jahr);
                // Status bewusst öffnen — sonst bleibt Panzerglas (abgeschlossen vom alten Jahr)
                updatedJahre = [{
                    ...updatedJahre[0],
                    jahr: targetYear,
                    status: 'datenerfassung',
                }];
            } else if (!hasTarget) {
                updatedJahre = [
                    ...updatedJahre,
                    {
                        jahr: targetYear,
                        status: 'datenerfassung',
                        bwaUrl: '',
                        bwaUrls: [],
                    },
                ];
            } else {
                // Zieljahr existiert: wenn abgeschlossen → öffnen (Admin will arbeiten)
                updatedJahre = updatedJahre.map((j: any) =>
                    Number(j.jahr) === targetYear
                        ? { ...j, status: j.status === 'abgeschlossen' ? 'datenerfassung' : (j.status || 'datenerfassung') }
                        : j
                );
            }

            // Jahr-Subdokument: bei Umbenennung Daten mitnehmen
            if (renamedFrom != null && renamedFrom !== targetYear) {
                const oldYearRef = doc(db, 'kalkulation_mandanten', selectedAkte.id, 'jahre', String(renamedFrom));
                const newYearRef = doc(db, 'kalkulation_mandanten', selectedAkte.id, 'jahre', String(targetYear));
                const oldYearSnap = await getDoc(oldYearRef);
                if (oldYearSnap.exists()) {
                    await setDoc(newYearRef, { ...oldYearSnap.data() }, { merge: true });
                    try { await deleteDoc(oldYearRef); } catch (_) { /* ignore */ }
                } else {
                    await setDoc(newYearRef, { bwaUrl: '', bwaUrls: [], clientData: { bwaUrl: '', bwaUrls: [] } }, { merge: true });
                }
            } else {
                const newYearRef = doc(db, 'kalkulation_mandanten', selectedAkte.id, 'jahre', String(targetYear));
                const newYearSnap = await getDoc(newYearRef);
                if (!newYearSnap.exists()) {
                    await setDoc(newYearRef, { bwaUrl: '', bwaUrls: [], clientData: { bwaUrl: '', bwaUrls: [] } }, { merge: true });
                }
            }

            // Mandantennummer-Jahrteil (z.B. 02/2027 → 02/2026), nur wenn Core klar ist
            const existingNr = String(selectedAkte.mandantNr || freshData.mandantNr || freshData.clientData?.mandantNr || '');
            let coreNr = extractCoreNumber(existingNr) || String(stammdatenEdit.coreMandantNr || '');
            let patchedCore = coreNr;
            if (coreNr && /\d{2}\/\d{4}/.test(coreNr)) {
                patchedCore = coreNr.replace(/\/\d{4}\b/, `/${targetYear}`);
            }

            const payload: Record<string, any> = {
                geschaeftsjahre: updatedJahre,
                'clientData.geschaeftsjahre': updatedJahre,
                aktivesJahr: String(targetYear),
                'clientData.aktivesJahr': String(targetYear),
                // HJ1-Sperre für Admin-Arbeit an dieser Akte lösen (sonst bleibt Tabelle read-only)
                isHJ1GesperrtGlobal: false,
                'clientData.isHJ1GesperrtGlobal': false,
            };

            if (patchedCore && patchedCore !== coreNr) {
                payload['clientData.mandantNrCoreHint'] = patchedCore;
                // Jahrteil in der sichtbaren Nummer mitschieben (nur /YYYY)
                if (existingNr && /\/\d{4}\b/.test(existingNr)) {
                    const patchedFull = existingNr.replace(/\/\d{4}\b/, `/${targetYear}`);
                    payload.mandantNr = patchedFull;
                    payload['clientData.mandantNr'] = patchedFull;
                }
            }

            await adminUpdateMandantRoot(selectedAkte.id, payload);

            setSelectedAkte({
                ...selectedAkte,
                geschaeftsjahre: updatedJahre,
                aktivesJahr: String(targetYear),
            } as any);

            if (patchedCore) {
                setStammdatenEdit((prev: any) => ({ ...prev, coreMandantNr: patchedCore }));
            }

            try {
                localStorage.setItem('CURRENT_YEAR', String(targetYear));
                sessionStorage.setItem('CURRENT_YEAR', String(targetYear));
                const statusHit = updatedJahre.find((j: any) => Number(j.jahr) === targetYear);
                const st = (statusHit?.status && String(statusHit.status).trim()) ? String(statusHit.status).trim() : 'datenerfassung';
                localStorage.setItem('CURRENT_YEAR_STATUS', st);
                window.dispatchEvent(new Event('pe-year-status'));
            } catch (_) { /* ignore */ }

            fetchClients();
            showNotification(
                renamedFrom != null
                    ? `Akte umgestellt: ${renamedFrom} → ${targetYear}.`
                    : `Geschäftsjahr ${targetYear} für diese Akte gesetzt.`,
                'success'
            );
        } catch (e) {
            console.error('handleSetAkteGeschaeftsjahr', e);
            showNotification('Fehler beim Setzen des Geschäftsjahres.', 'error');
        } finally {
            setIsSettingAkteJahr(false);
        }
    };

    const handleCancelSubmit = async () => {
        if (!cancelClient || !cancelMonth) return;
        setIsProcessingAction(true);
        try {
            const [yearStr, monthStr] = cancelMonth.split('-');
            const year = parseInt(yearStr, 10);
            const month = parseInt(monthStr, 10);
            const endDate = new Date(year, month, 0, 23, 59, 59); 
            const endDateStr = endDate.toISOString();

            if (endDate < new Date()) {
                await adminUpdateMandantRoot(cancelClient.id, { kuendigungsDatum: endDateStr, isArchived: true });
                showNotification(`Das Enddatum lag in der Vergangenheit. Akte archiviert.`, "success");
            } else {
                await adminUpdateMandantRoot(cancelClient.id, { kuendigungsDatum: endDateStr });
                showNotification(`Kündigung vorgemerkt zum ${endDate.toLocaleDateString('de-DE')}.`, "success");
            }
            setShowCancelModal(false);
            setCancelClient(null);
            setCancelMonth('');
            fetchClients();
        } catch (e) {
            showNotification("Fehler beim Einleiten der Kündigung.", "error");
        } finally {
            setIsProcessingAction(false);
        }
    };

    const isMartinaMember = (m: any) =>
        m?.name === 'Martina' ||
        m?.email?.toLowerCase()?.includes('martina') ||
        m?.email?.toLowerCase() === 'coaching@preisexpert.info';

    /** Notfall: Martina → Superadmin (bei Abwesenheit). Mit gleichem Master-Key wieder rückgängig. */
    const handleEmergencyUnlock = async (mode: 'promote' | 'revert' = 'promote') => {
        if (emergencyCode !== 'OMEGA-99') {
            setEmergencyError(true);
            setEmergencyCode('');
            return;
        }

        setIsPromoting(true);
        try {
            const sysRef = doc(db, 'system_data', 'global_settings');
            const sysDoc = await getDoc(sysRef);

            if (sysDoc.exists()) {
                const data = sysDoc.data();
                let currentTeam = data.team || [];
                let martinaFound = false;
                currentTeam = currentTeam.map((m: any) => {
                    if (!isMartinaMember(m)) return m;
                    martinaFound = true;
                    if (mode === 'promote') {
                        return {
                            ...m,
                            role: 'superadmin',
                            category: 'admin',
                            _emergencySuperadmin: true,
                            _roleBeforeEmergency: m.role || 'admin',
                        };
                    }
                    // Revert: zurück auf vorherige Rolle (Default admin)
                    const prev = m._roleBeforeEmergency || 'admin';
                    const { _emergencySuperadmin, _roleBeforeEmergency, ...rest } = m;
                    return { ...rest, role: prev === 'superadmin' ? 'admin' : prev, category: 'admin' };
                });

                if (martinaFound) {
                    await updateDoc(sysRef, { team: currentTeam });
                    useAppStore.setState({ team: currentTeam });
                    showNotification(
                        mode === 'promote'
                            ? 'NOTFALL: Martina hat jetzt Super-Admin Rechte.'
                            : 'NOTFALL ZURÜCKGESETZT: Martina ist wieder normale Admin-Rechte.',
                        'success'
                    );
                } else {
                    showNotification('Martina wurde im Team nicht gefunden.', 'error');
                }
            }
            setShowEmergencyModal(false);
            setEmergencyCode('');
            setEmergencyError(false);
        } catch (err) {
            showNotification('Datenbank-Fehler beim Notfall-Protokoll.', 'error');
        } finally {
            setIsPromoting(false);
        }
    };

    const openAkte = (client: PendingClient) => {
        const data = client.clientData || {};
        
        let initialVertragsbeginn = '';
        const rawDate = data.vertragsbeginn || client.vertragsbeginn || '';
        if (rawDate && typeof rawDate === 'string') {
            if (rawDate.includes('/')) {
                const parts = rawDate.split('/');
                if (parts.length === 2) {
                    const mm = parts[0].padStart(2, '0');
                    const core = `${mm}/${parts[1]}`;
                    if (isValidMonthYearCore(core)) {
                        initialVertragsbeginn = `${parts[1]}-${mm}`;
                    }
                }
            } else if (/^\d{4}-\d{2}/.test(rawDate)) {
                const [y, m] = rawDate.split('-');
                if (isValidMonthYearCore(`${m}/${y}`)) {
                    initialVertragsbeginn = `${y}-${m}`;
                }
            } else {
                const d = new Date(rawDate);
                if (!isNaN(d.getTime())) {
                    initialVertragsbeginn = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                }
            }
        }
        // Nur echter Kalendermonat (01–12) aus der Nummer — nie laufende Nummer wie 14/2026
        if (!initialVertragsbeginn) {
            const coreFromNr = extractCoreNumber((client.mandantNr || data.mandantNr || '').trim());
            if (isValidMonthYearCore(coreFromNr)) {
                const [mm, yyyy] = coreFromNr.split('/');
                initialVertragsbeginn = `${yyyy}-${mm}`;
            }
        }

        const savedForceSolo = readForceSoloTarif(client);

        let initialLizenz = '';
        const lizenzRaw = data.lizenzDetails?.typ;
        if (lizenzRaw) {
            initialLizenz = lizenzRaw;
        } else if (data.basicChecked) {
            initialLizenz = 'basic';
        } else if (data.insiderTeamleaderStandardChecked || data.insiderTeamleaderPlusChecked || data.insiderSoloChecked) {
            initialLizenz = 'insider';
        } else if (!client.isLegacy) {
            initialLizenz = 'insider'; 
        }

        const adminMember = resolveClientCoach(client, coachLookupPool);
        const coachInitial = adminMember ? adminMember.name.charAt(0).toUpperCase() : '';

        // 💉 FIX: Fallback greift jetzt auch bei Leerzeichen-Strings
        const rawClientNr = (client.mandantNr || '').trim();
        const rawDataNr = (data.mandantNr || '').trim();
        const rawMandantNr = rawClientNr || rawDataNr || '';
        const safeCoreNumber = extractCoreNumber(rawMandantNr);

        // Team-Signal aus Nummer schlägt stale isSolo/forceSolo (Cleanup-Regression).
        // Bewusster Solo-Override setzt die Nummer beim Speichern auf Solo um.
        const peoLetter = readPeoLetterFromMandantNr(rawMandantNr);
        const parsedNr = parseMandantNr(rawMandantNr);
        const teamSignalFromNr =
            peoLetter === 'T' ||
            peoLetter === 'B' ||
            parsedNr.tarifStatus === 'TeamPro' ||
            parsedNr.tarifStatus === 'TeamBase' ||
            parsedNr.tarifStatus === 'TeamPro+';
        
        let safeUnternehmensform = client.unternehmensform || data.unternehmensform || client.rechtsform || data.rechtsform || '';
        safeUnternehmensform = safeUnternehmensform.trim();

        const isLegacyClient = !!client.isLegacy;
        const proBonoOpen = data.proBonoActive || client.proBonoActive || false;
        const manualOverrideOpen = !!(
            client.neukundenManualOverride ?? data.neukundenManualOverride
        );
        const feePremiumOpen = client.forceNewCustomerPremium ?? data.forceNewCustomerPremium ?? false;
        const feeDisableOpen = client.disableNewCustomerPremium ?? data.disableNewCustomerPremium ?? false;
        const autoFromNr = isNeukundenYearFromMandantNr(rawMandantNr || safeCoreNumber);
        // Ohne echten Manual-Override: immer Jahr aus Nummer (alte Force-Flags ignorieren)
        const neukundenAufschlagOpen = manualOverrideOpen
            ? feePremiumOpen && !feeDisableOpen
                ? true
                : feeDisableOpen && !feePremiumOpen
                  ? false
                  : autoFromNr
            : autoFromNr;
        const loadedIsSolo = client.isSolo === true || data.isSolo === true;
        // Team in der Nummer = kein Solo-Zwang (auch nicht über stale forceSolo/isSolo).
        // Bewusster Solo-Override setzt die Nummer beim Speichern auf Solo um.
        const soloOn = !teamSignalFromNr && (!!savedForceSolo || loadedIsSolo);
        const loadedHasEmployeeEval = client.hasEmployeeEval === true || data.hasEmployeeEval === true;
        const loadedIsBestandskunde = !neukundenAufschlagOpen;
        const liveMonthlyFee = calculateClientMonthlyFee({
            settings,
            lizenzTyp: initialLizenz,
            client: {
                ...client,
                isSolo: soloOn,
                hasEmployeeEval: soloOn ? false : loadedHasEmployeeEval,
                isBestandskunde: loadedIsBestandskunde,
                neukundenManualOverride: manualOverrideOpen,
            },
            forceSoloTarif: soloOn,
            isSolo: soloOn,
            hasEmployeeEval: soloOn ? false : loadedHasEmployeeEval,
            isNewCustomer: neukundenAufschlagOpen,
            forceNewCustomerPremium: neukundenAufschlagOpen,
            disableNewCustomerPremium: !neukundenAufschlagOpen,
            neukundenManualOverride: manualOverrideOpen,
            mandantNr: rawMandantNr,
            isProBono: proBonoOpen,
        });

        setStammdatenEdit({
            coreMandantNr: safeCoreNumber,
            coachInitial: coachInitial,
            
            land: client.land || data.land || 'DE', 
            umsatzsteuerbefreit: Boolean(
                client.umsatzsteuerbefreit ??
                    data.umsatzsteuerbefreit ??
                    client.isVatExempt ??
                    data.isVatExempt ??
                    false
            ),
            forceSoloTarif: soloOn,
            isSolo: soloOn,
            hasEmployeeEval: soloOn ? false : loadedHasEmployeeEval,
            isBestandskunde: loadedIsBestandskunde,
            neukundenAufschlag: neukundenAufschlagOpen,
            neukundenManualOverride: manualOverrideOpen,
            forceNewCustomerPremium: neukundenAufschlagOpen,
            disableNewCustomerPremium: !neukundenAufschlagOpen, 
            unternehmensform: safeUnternehmensform,
            unternehmername: data.unternehmername || (client.vorname + " " + client.nachname).trim() || '',
            salonname: data.salonname || client.firmenname || '',
            mailadresse: data.mailadresse || client.email || '',
            whatsappNr: data.whatsappNr || client.telefon || '',
            salonFestnetz: String(data.salonFestnetz || client.salonFestnetz || data.festnetz || client.festnetz || '').trim(),
            branchName: String(data.branchName || client.branchName || '').trim(),
            hasBranches: !!(client.hasBranches || data.hasBranches),
            branches: Array.isArray(client.branches) && client.branches.length
                ? client.branches
                : (Array.isArray(data.branches) ? data.branches : []),
            activeBranchId: String(client.activeBranchId || data.activeBranchId || '').trim(),
            strasse: data.strasse || client.strasse || '',
            plz: data.plz || client.plz || '',
            ort: data.ort || client.ort || '',
            lizenzTyp: initialLizenz,
            insiderTeamleaderStandardChecked: data.insiderTeamleaderStandardChecked || false,
            insiderTeamleaderPlusChecked: data.insiderTeamleaderPlusChecked || false,
            basicChecked: data.basicChecked || false,
            vertragsbeginn: initialVertragsbeginn,
            proBonoActive: proBonoOpen,
            proBonoUntil: data.proBonoUntil || client.proBonoUntil || '',
            monthlyFee: isLegacyClient
                ? (client.monthlyFee ?? data.monthlyFee ?? '')
                : formatMonthlyFeeDe(liveMonthlyFee),
            isLegacy: isLegacyClient,

            wochensatz: data.wochensatz ?? DEFAULT_MANDANTEN_PARAMETER.wochensatz,
            auslastungsfaktor: data.auslastungsfaktor ?? DEFAULT_MANDANTEN_PARAMETER.auslastungsfaktor,
            auslastungsfaktorMax: data.auslastungsfaktorMax ?? DEFAULT_MANDANTEN_PARAMETER.auslastungsfaktorMax,
            zusatzumsatz: data.zusatzumsatz ?? DEFAULT_MANDANTEN_PARAMETER.zusatzumsatz,
            gewinnlinie: data.gewinnlinie ?? DEFAULT_MANDANTEN_PARAMETER.gewinnlinie,
            investlinie: data.investlinie ?? DEFAULT_MANDANTEN_PARAMETER.investlinie,
            verlust1: data.verlust1 ?? DEFAULT_MANDANTEN_PARAMETER.verlust1,
            liquiditaet: data.liquiditaet ?? DEFAULT_MANDANTEN_PARAMETER.liquiditaet
        });
        setDrawerTab('jahre');
        const years =
            (Array.isArray(client.geschaeftsjahre) && client.geschaeftsjahre.length > 0)
                ? client.geschaeftsjahre
                : (Array.isArray(client.clientData?.geschaeftsjahre) ? client.clientData.geschaeftsjahre : []);
        setSelectedAkte({ ...client, geschaeftsjahre: years });
        if (years.length > 0) {
            const maxY = Math.max(...years.map((j: any) => Number(j.jahr) || 0));
            if (Number.isFinite(maxY) && maxY > 0) setAkteZielJahr(maxY);
        } else {
            setAkteZielJahr(2026);
        }

        // Bestehende Chronik-Duplikate in Firestore bereinigen (einmalig beim Öffnen)
        const chronikRaw = client.clientData?.aenderungsChronik || client.aenderungsChronik || [];
        if (Array.isArray(chronikRaw) && chronikRaw.length > 1 && client.id) {
            const seen = new Set<string>();
            const deduped = chronikRaw.filter((e: any) => {
                const key = `${e?.createdAt || ''}|${e?.authorName || ''}|${e?.description || ''}|${e?.draftId || ''}|${e?.category || ''}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
            if (deduped.length < chronikRaw.length) {
                const cleanedClient = {
                    ...client,
                    clientData: { ...(client.clientData || {}), aenderungsChronik: deduped },
                    aenderungsChronik: deduped,
                };
                setSelectedAkte(cleanedClient);
                void adminUpdateMandantRoot(client.id, {
                    'clientData.aenderungsChronik': deduped,
                }).catch((err) => console.warn('Chronik-Dedup Persist fehlgeschlagen:', err));
            }
        }
    };

    const openFilialModal = () => {
        if (!selectedAkte) return;
        const data = selectedAkte.clientData || {};
        const existing = Array.isArray(stammdatenEdit.branches) && stammdatenEdit.branches.length
            ? stammdatenEdit.branches
            : (Array.isArray(selectedAkte.branches) && selectedAkte.branches.length
                ? selectedAkte.branches
                : (Array.isArray(data.branches) ? data.branches : []));
        if (existing.length > 0) {
            setFilialDraft(existing.map((b: any) => ({
                id: String(b.id || 'main'),
                name: String(b.name || 'Hauptsalon'),
                isMain: !!b.isMain,
                createdAt: String(b.createdAt || new Date().toISOString()),
            })));
        } else {
            const mainName = String(
                stammdatenEdit.branchName
                || data.branchName
                || stammdatenEdit.salonname
                || data.salonname
                || selectedAkte.firmenname
                || 'Hauptsalon'
            ).trim() || 'Hauptsalon';
            setFilialDraft([{
                id: 'main',
                name: mainName,
                isMain: true,
                createdAt: new Date().toISOString(),
            }]);
        }
        setShowFilialModal(true);
    };

    const addFilialeToDraft = () => {
        const n = filialDraft.filter((b) => !b.isMain).length + 2;
        setFilialDraft((prev) => [
            ...prev,
            {
                id: `branch_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
                name: `Filiale ${n}`,
                isMain: false,
                createdAt: new Date().toISOString(),
            },
        ]);
    };

    const saveFilialBetrieb = async () => {
        if (!selectedAkte) return;
        if (!filialDraft.length || !filialDraft.some((b) => b.isMain)) {
            showNotification('Mindestens eine Hauptfiliale ist erforderlich.', 'error');
            return;
        }
        const cleaned = filialDraft.map((b) => ({
            id: String(b.id || '').trim(),
            name: String(b.name || '').trim() || (b.isMain ? 'Hauptsalon' : 'Filiale'),
            isMain: !!b.isMain,
            createdAt: b.createdAt || new Date().toISOString(),
        })).filter((b) => b.id);
        const main = cleaned.find((b) => b.isMain) || cleaned[0];
        const activeBranchId = String(stammdatenEdit.activeBranchId || main.id);

        setIsSavingFilialen(true);
        try {
            const { initializeBranchYearDoc } = await import('../config/firebaseSync');
            const years = (
                (Array.isArray(selectedAkte.geschaeftsjahre) && selectedAkte.geschaeftsjahre.length > 0)
                    ? selectedAkte.geschaeftsjahre
                    : (Array.isArray(selectedAkte.clientData?.geschaeftsjahre)
                        ? selectedAkte.clientData.geschaeftsjahre
                        : [])
            ).map((j: any) => String(j.jahr)).filter(Boolean);
            if (years.length === 0) {
                showNotification('Keine Geschäftsjahre vorhanden — bitte zuerst ein Jahr setzen.', 'error');
                return;
            }
            const identitySeed = {
                firmenname: stammdatenEdit.salonname || selectedAkte.firmenname || '',
                salonname: stammdatenEdit.salonname || selectedAkte.firmenname || '',
                unternehmername: stammdatenEdit.unternehmername || '',
                mailadresse: stammdatenEdit.mailadresse || selectedAkte.email || '',
                whatsappNr: stammdatenEdit.whatsappNr || selectedAkte.telefon || '',
                strasse: stammdatenEdit.strasse || '',
                plz: stammdatenEdit.plz || '',
                ort: stammdatenEdit.ort || '',
                land: stammdatenEdit.land || 'DE',
                mandantNr: selectedAkte.mandantNr || '',
            };

            for (const branch of cleaned) {
                if (branch.isMain) continue;
                for (const year of years) {
                    await initializeBranchYearDoc(selectedAkte.id, year, branch, identitySeed);
                }
            }

            await adminSetMandantRoot(selectedAkte.id, {
                hasBranches: true,
                branches: cleaned,
                activeBranchId,
                branchName: main.name,
                clientData: {
                    hasBranches: true,
                    branches: cleaned,
                    activeBranchId,
                    branchName: main.name,
                },
            }, true);

            setStammdatenEdit((prev: any) => ({
                ...prev,
                hasBranches: true,
                branches: cleaned,
                activeBranchId,
                branchName: main.name,
            }));
            setSelectedAkte({
                ...selectedAkte,
                hasBranches: true,
                branches: cleaned,
                activeBranchId,
                branchName: main.name,
                clientData: {
                    ...(selectedAkte.clientData || {}),
                    hasBranches: true,
                    branches: cleaned,
                    activeBranchId,
                    branchName: main.name,
                },
            } as any);
            setShowFilialModal(false);
            showNotification('Filialbetrieb gespeichert.', 'success');
        } catch (e: any) {
            console.error(e);
            showNotification(e?.message || 'Filialbetrieb konnte nicht gespeichert werden.', 'error');
        } finally {
            setIsSavingFilialen(false);
        }
    };

    const saveStammdaten = async () => {
        if (!selectedAkte) return;
        setDrawerIsSaving(true);
        try {
            // 💉 ANTI-LOBOTOMIE: State-Verlust abfangen
            let newCoreNr = stammdatenEdit.coreMandantNr;
            if (!newCoreNr || newCoreNr.trim() === '') {
                const backupNr = selectedAkte.mandantNr || selectedAkte.clientData?.mandantNr || '';
                newCoreNr = extractCoreNumber(backupNr);
            }
            // Alt-/Giftdaten: MM.YYYY → MM/YYYY (auch bei manueller Eingabe)
            if (newCoreNr) {
                newCoreNr = String(newCoreNr).replace(/(\d{2})\.(\d{4})/g, '$1/$2');
            }

            const existingNr = selectedAkte.mandantNr || selectedAkte.clientData?.mandantNr || '';
            const isLegacySave = !!stammdatenEdit.isLegacy;

            // Vorabkunden: Nummer NIEMALS auf Solo/Team-Format migrieren —
            // aber immer auf sauberes `MA NN/YYYY-X` normalisieren (+ Coach-Initial).
            let newMandantNr = existingNr;
            if (isLegacySave) {
                const coachLetter =
                    stammdatenEdit.coachInitial ||
                    resolveCoachInitialLetter(
                        assignableTeam.find((c) => c.id === (selectedAkte.betreuer || selectedAkte.coachId))?.name ||
                            selectedAkte.betreuer ||
                            selectedAkte.coachId,
                        assignableTeam
                    );
                const coreForVorab =
                    (newCoreNr && /^\d{1,2}\/\d{4}$/.test(String(newCoreNr).trim())
                        ? String(newCoreNr).trim().replace(/^(\d{1,2})\//, (_, m) => `${String(m).padStart(2, '0')}/`)
                        : '') ||
                    extractCoreNumber(existingNr) ||
                    '';
                newMandantNr =
                    normalizeVorabMandantNr(
                        coreForVorab ? `MA ${coreForVorab}` : existingNr,
                        coachLetter
                    ) ||
                    normalizeVorabMandantNr(existingNr, coachLetter) ||
                    existingNr ||
                    '';
            } else {
                newMandantNr = migrateMandantNrIfNeeded({
                    existingNr,
                    isLegacy: false,
                    core: newCoreNr || extractCoreNumber(existingNr),
                    coachInitial: stammdatenEdit.coachInitial || null,
                    client: {
                        ...selectedAkte,
                        isSolo: stammdatenEdit.isSolo,
                        hasEmployeeEval: stammdatenEdit.hasEmployeeEval,
                        isTeamProPlus: !stammdatenEdit.isSolo && !stammdatenEdit.forceSoloTarif && !!stammdatenEdit.insiderTeamleaderPlusChecked,
                        insiderTeamleaderPlusChecked: !stammdatenEdit.isSolo && !stammdatenEdit.forceSoloTarif && !!stammdatenEdit.insiderTeamleaderPlusChecked,
                        isBestandskunde: stammdatenEdit.isBestandskunde,
                        forceSoloTarif: stammdatenEdit.forceSoloTarif,
                    },
                    settings,
                    forceSoloTarif: !!stammdatenEdit.forceSoloTarif,
                    isSolo: typeof stammdatenEdit.isSolo === 'boolean'
                        ? stammdatenEdit.isSolo
                        : (stammdatenEdit.forceSoloTarif ? true : undefined),
                    hasEmployeeEval: stammdatenEdit.isSolo
                        ? false
                        : (typeof stammdatenEdit.hasEmployeeEval === 'boolean'
                            ? stammdatenEdit.hasEmployeeEval
                            : undefined),
                    lizenzTyp: stammdatenEdit.lizenzTyp,
                });
                if (!newMandantNr && newCoreNr) {
                    const tier = !stammdatenEdit.isSolo && !stammdatenEdit.forceSoloTarif && stammdatenEdit.insiderTeamleaderPlusChecked
                        ? 'teamProPlus'
                        : resolveTarifTier({
                            settings,
                            client: {
                                ...selectedAkte,
                                isSolo: stammdatenEdit.isSolo,
                                hasEmployeeEval: stammdatenEdit.hasEmployeeEval,
                                isBestandskunde: stammdatenEdit.isBestandskunde,
                            },
                            forceSoloTarif: !!stammdatenEdit.forceSoloTarif,
                            isSolo: typeof stammdatenEdit.isSolo === 'boolean'
                                ? stammdatenEdit.isSolo
                                : (stammdatenEdit.forceSoloTarif ? true : undefined),
                            hasEmployeeEval: stammdatenEdit.isSolo
                                ? false
                                : (typeof stammdatenEdit.hasEmployeeEval === 'boolean'
                                    ? stammdatenEdit.hasEmployeeEval
                                    : undefined),
                            lizenzTyp: stammdatenEdit.lizenzTyp,
                        });
                    newMandantNr = buildMandantNr({
                        core: newCoreNr,
                        coachInitial: stammdatenEdit.coachInitial || null,
                        tarifStatus: tarifStatusFromTier(tier),
                    });
                }
            }

            // Häkchen + optional Manual-Override (sonst gilt immer das Jahr aus der Nummer)
            const forcePremium = !!stammdatenEdit.neukundenAufschlag;
            const disablePremium = !forcePremium;
            const autoFromNr = isNeukundenYearFromMandantNr(newCoreNr || newMandantNr);
            const neukundenManualOverride =
                !!stammdatenEdit.neukundenManualOverride && forcePremium !== autoFromNr;
            const isPremium2027 = forcePremium;

            const isBasic = stammdatenEdit.lizenzTyp === 'basic';
            const isInsider = stammdatenEdit.lizenzTyp === 'insider';

            let formattedVertragsbeginn: string | null = null;
            // Manuelle Basisnummer mit echtem Monat (01–12) hat Vorrang — z. B. 08/2026 statt alter 12
            if (isValidMonthYearCore(newCoreNr)) {
                formattedVertragsbeginn = newCoreNr;
            } else if (stammdatenEdit.vertragsbeginn) {
                const parts = stammdatenEdit.vertragsbeginn.split('-');
                if (parts.length === 2) {
                    const candidate = `${parts[1]}/${parts[0]}`;
                    formattedVertragsbeginn = isValidMonthYearCore(candidate) ? candidate : null;
                }
            }

            const nameStr = stammdatenEdit.unternehmername || '';
            const nameParts = nameStr.trim().split(' ');
            const newVorname = nameParts[0] || '';
            const newNachname = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
            const newFirmenname = stammdatenEdit.salonname || '';

            const proBonoActive = !!stammdatenEdit.proBonoActive;

            // Auto-Preis inkl. Neukunden-Aufschlag (auch bei Pro-Bono als Soll-Preis berechnen)
            let parsedMonthlyFee = 0;
            if (!stammdatenEdit.isLegacy && settings?.global) {
                parsedMonthlyFee = calculateClientMonthlyFee({
                    settings,
                    lizenzTyp: stammdatenEdit.lizenzTyp,
                    client: {
                        ...selectedAkte,
                        isSolo: !!stammdatenEdit.isSolo,
                        hasEmployeeEval: !!stammdatenEdit.hasEmployeeEval,
                        isBestandskunde: !forcePremium,
                        forceSoloTarif: stammdatenEdit.forceSoloTarif,
                        forceNewCustomerPremium: forcePremium,
                        disableNewCustomerPremium: disablePremium,
                        neukundenManualOverride,
                        isPremium2027: !!isPremium2027,
                    },
                    forceSoloTarif: stammdatenEdit.forceSoloTarif,
                    isSolo: !!stammdatenEdit.isSolo,
                    hasEmployeeEval: !!stammdatenEdit.hasEmployeeEval,
                    isNewCustomer: forcePremium,
                    forceNewCustomerPremium: forcePremium,
                    disableNewCustomerPremium: disablePremium,
                    neukundenManualOverride,
                    mandantNr: newMandantNr,
                    isProBono: false,
                });
            } else if (stammdatenEdit.monthlyFee) {
                const parsed = parseFloat(stammdatenEdit.monthlyFee.toString().replace(',', '.'));
                if (!isNaN(parsed)) {
                    parsedMonthlyFee = parsed;
                }
            }

            const zeitraum = selectedAkte?.clientData?.bwaData?.zeitraum ?? 12;
            // Pro-Bono: Soll-Tarif (inkl. Neukunden-Aufschlag) weiter speichern — Anzeige/Vertrag brauchen ihn.
            // Nur BWA/Abrechnung wird auf 0 gesetzt.
            const effectiveMonthlyFee = parsedMonthlyFee;
            const billedMonthlyFee = proBonoActive ? 0 : parsedMonthlyFee;
            const preisExpertJahr = billedMonthlyFee * zeitraum;
            const existingBwaData = selectedAkte.clientData?.bwaData || {};

            const mandantenParameter = {
                wochensatz: parseParam(stammdatenEdit.wochensatz, 4.33),
                auslastungsfaktor: parseParam(stammdatenEdit.auslastungsfaktor, 75),
                auslastungsfaktorMax: parseParam(stammdatenEdit.auslastungsfaktorMax, 100),
                zusatzumsatz: parseParam(stammdatenEdit.zusatzumsatz, 30),
                gewinnlinie: parseParam(stammdatenEdit.gewinnlinie, 26),
                investlinie: parseParam(stammdatenEdit.investlinie, 5),
                verlust1: parseParam(stammdatenEdit.verlust1, 15),
                liquiditaet: parseParam(stammdatenEdit.liquiditaet, 10),
            };

            const rootPayload: any = {
                isUnlockedByAdmin: true, 
                firmenname: newFirmenname || '',
                vorname: newVorname || '',
                nachname: newNachname || '',
                email: stammdatenEdit.mailadresse || '',
                telefon: stammdatenEdit.whatsappNr || '',
                salonFestnetz: stammdatenEdit.salonFestnetz || '',
                branchName: stammdatenEdit.branchName || '',
                strasse: stammdatenEdit.strasse || '',
                plz: stammdatenEdit.plz || '',
                ort: stammdatenEdit.ort || '',
                land: stammdatenEdit.land || 'DE',
                unternehmensform: stammdatenEdit.unternehmensform || '',
                rechtsform: stammdatenEdit.unternehmensform || '',
                umsatzsteuerbefreit: !!stammdatenEdit.umsatzsteuerbefreit,
                isVatExempt: !!stammdatenEdit.umsatzsteuerbefreit,
                // Vorab: Flags speichern für Badge Solo/TeamBase/TeamPro — Nummer bleibt ohne Tarif-Suffix
                forceSoloTarif: !!(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo),
                isSolo: !!(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo),
                hasEmployeeEval: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                    ? false
                    : !!stammdatenEdit.hasEmployeeEval,
                packageTier: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                    ? 'solo'
                    : (stammdatenEdit.insiderTeamleaderPlusChecked ? 'teamProPlus' : (stammdatenEdit.hasEmployeeEval ? 'teamPro' : 'teamBase')),
                tarifStatus: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                    ? 'Solo'
                    : (stammdatenEdit.insiderTeamleaderPlusChecked ? 'TeamPro+' : (stammdatenEdit.hasEmployeeEval ? 'TeamPro' : 'TeamBase')),
                isTeamProPlus: !(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo) && !!stammdatenEdit.insiderTeamleaderPlusChecked,
                insiderTeamleaderPlusChecked: !(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo) && !!stammdatenEdit.insiderTeamleaderPlusChecked,
                isBestandskunde: !forcePremium,
                forceNewCustomerPremium: !!forcePremium,
                disableNewCustomerPremium: !!disablePremium,
                neukundenManualOverride: !!neukundenManualOverride,
                isPremium2027: !!isPremium2027,
                mandantNr: newMandantNr || '',
                vertragsbeginn: formattedVertragsbeginn || null,
                createdAt: selectedAkte.createdAt || new Date().toISOString(),
                proBonoActive: proBonoActive,
                proBonoUntil: stammdatenEdit.proBonoUntil || '',
                monthlyFee: effectiveMonthlyFee || 0,
                isLegacy: !!stammdatenEdit.isLegacy,
                lizenzDetails: { typ: stammdatenEdit.lizenzTyp || '' },
                clientData: {
                    isUnlockedByAdmin: true,
                    mandantNr: newMandantNr || '', 
                    land: stammdatenEdit.land || 'DE', 
                    unternehmensform: stammdatenEdit.unternehmensform || '',
                    rechtsform: stammdatenEdit.unternehmensform || '',
                    umsatzsteuerbefreit: !!stammdatenEdit.umsatzsteuerbefreit,
                    isVatExempt: !!stammdatenEdit.umsatzsteuerbefreit,
                    forceSoloTarif: !!(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo),
                    isSolo: !!(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo),
                    hasEmployeeEval: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                        ? false
                        : !!stammdatenEdit.hasEmployeeEval,
                    packageTier: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                        ? 'solo'
                        : (stammdatenEdit.insiderTeamleaderPlusChecked ? 'teamProPlus' : (stammdatenEdit.hasEmployeeEval ? 'teamPro' : 'teamBase')),
                    tarifStatus: (stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo)
                        ? 'Solo'
                        : (stammdatenEdit.insiderTeamleaderPlusChecked ? 'TeamPro+' : (stammdatenEdit.hasEmployeeEval ? 'TeamPro' : 'TeamBase')),
                    isTeamProPlus: !(stammdatenEdit.forceSoloTarif || stammdatenEdit.isSolo) && !!stammdatenEdit.insiderTeamleaderPlusChecked,
                    isBestandskunde: !forcePremium,
                    forceNewCustomerPremium: !!forcePremium,
                    disableNewCustomerPremium: !!disablePremium,
                    neukundenManualOverride: !!neukundenManualOverride,
                    isPremium2027: !!isPremium2027,
                    unternehmername: stammdatenEdit.unternehmername || '',
                    salonname: newFirmenname || '',
                    mailadresse: stammdatenEdit.mailadresse || '',
                    whatsappNr: stammdatenEdit.whatsappNr || '',
                    salonFestnetz: stammdatenEdit.salonFestnetz || '',
                    branchName: stammdatenEdit.branchName || '',
                    strasse: stammdatenEdit.strasse || '',
                    plz: stammdatenEdit.plz || '',
                    ort: stammdatenEdit.ort || '',
                    basicChecked: !!isBasic,
                    insiderTeamleaderStandardChecked: !!isInsider,
                    insiderTeamleaderPlusChecked: !!stammdatenEdit.insiderTeamleaderPlusChecked,
                    lizenzDetails: { typ: stammdatenEdit.lizenzTyp || '' },
                    vertragsbeginn: formattedVertragsbeginn || null,
                    proBonoActive: proBonoActive,
                    proBonoChecked: proBonoActive,
                    proBonoUntil: stammdatenEdit.proBonoUntil || '',
                    monthlyFee: effectiveMonthlyFee || 0,
                    bwaData: {
                        ...existingBwaData,
                        preisExpert: preisExpertJahr,
                    },
                    ...mandantenParameter 
                },
                settings: {
                    selectedCountryId: stammdatenEdit.land || 'DE'
                }
            };

            // Vorabkunden: Nummer immer mitschreiben (nie löschen) — bereits normalisiert
            if (isLegacySave) {
                rootPayload.mandantNr = newMandantNr;
                rootPayload.customerNumber = newMandantNr;
                if (rootPayload.clientData) {
                    rootPayload.clientData.mandantNr = newMandantNr;
                    rootPayload.clientData.customerNumber = newMandantNr;
                }
            }

            await adminSetMandantRoot(selectedAkte.id, rootPayload, true);

            // Nur bestehende Geschäftsjahre anfassen — nie Kalenderjahr „erfinden“
            const yearsList =
                (Array.isArray(selectedAkte.geschaeftsjahre) && selectedAkte.geschaeftsjahre.length > 0)
                    ? selectedAkte.geschaeftsjahre
                    : (Array.isArray(selectedAkte.clientData?.geschaeftsjahre)
                        ? selectedAkte.clientData.geschaeftsjahre
                        : []);
            for (const jahrItem of yearsList) {
                const jahrStr = String(jahrItem?.jahr ?? '').trim();
                if (!jahrStr) continue;
                const yearRef = doc(db, 'kalkulation_mandanten', selectedAkte.id, 'jahre', jahrStr);
                await setDoc(yearRef, {
                    clientData: rootPayload.clientData
                }, { merge: true });
            }

            const preservedJahre = yearsList;
            setSelectedAkte({
                ...selectedAkte,
                isUnlockedByAdmin: true,
                firmenname: newFirmenname,
                vorname: newVorname,
                nachname: newNachname,
                email: stammdatenEdit.mailadresse,
                telefon: stammdatenEdit.whatsappNr,
                salonFestnetz: stammdatenEdit.salonFestnetz || '',
                branchName: stammdatenEdit.branchName || '',
                strasse: stammdatenEdit.strasse,
                plz: stammdatenEdit.plz,
                ort: stammdatenEdit.ort,
                mandantNr: newMandantNr,
                unternehmensform: stammdatenEdit.unternehmensform || '',
                monthlyFee: effectiveMonthlyFee,
                isLegacy: !!stammdatenEdit.isLegacy,
                vertragsbeginn: formattedVertragsbeginn || null,
                createdAt: selectedAkte.createdAt,
                proBonoActive: proBonoActive,
                proBonoUntil: stammdatenEdit.proBonoUntil || '',
                forceNewCustomerPremium: forcePremium,
                disableNewCustomerPremium: disablePremium,
                neukundenManualOverride: !!neukundenManualOverride,
                isBestandskunde: !forcePremium,
                isPremium2027: !!isPremium2027,
                geschaeftsjahre: preservedJahre,
                clientData: {
                    ...(selectedAkte.clientData || {}),
                    ...rootPayload.clientData,
                    geschaeftsjahre: preservedJahre.length
                        ? preservedJahre
                        : (selectedAkte.clientData?.geschaeftsjahre || []),
                }
            });

            if (impersonatedClientId === selectedAkte.id) {
                const store = useAppStore.getState();
                // Zuerst clientData.land, dann Settings — sonst klebt DE-Lohnnebenkosten am Profil
                store.setClientData((prev: any) => ({
                    ...prev,
                    ...rootPayload.clientData,
                    // Geschäftsjahre nie durch Stammdaten-Save überschreiben/löschen
                    geschaeftsjahre: Array.isArray(prev?.geschaeftsjahre) && prev.geschaeftsjahre.length
                        ? prev.geschaeftsjahre
                        : (preservedJahre.length ? preservedJahre : prev?.geschaeftsjahre),
                    // Root-Flags explizit (God-Mode-Store darf sie nicht verlieren)
                    umsatzsteuerbefreit: !!rootPayload.umsatzsteuerbefreit,
                    isVatExempt: !!rootPayload.isVatExempt,
                    forceNewCustomerPremium: !!rootPayload.forceNewCustomerPremium,
                    disableNewCustomerPremium: !!rootPayload.disableNewCustomerPremium,
                    neukundenManualOverride: !!rootPayload.neukundenManualOverride,
                    isPremium2027: !!rootPayload.isPremium2027,
                    monthlyFee: rootPayload.monthlyFee,
                    proBonoActive: !!rootPayload.proBonoActive,
                    proBonoUntil: rootPayload.proBonoUntil || '',
                    isBestandskunde: !!rootPayload.isBestandskunde,
                }));
            }

            showNotification("Stammdaten gespeichert und Akte freigeschaltet!", "success");
            fetchClients(); 
        } catch (error) {
            console.error("Speicher-Fehler Firestore:", error);
            showNotification("Fehler beim Speichern.", "error");
        } finally {
            setDrawerIsSaving(false);
        }
    };

    const handleCoachChange = async (clientId: string, newCoachId: string) => {
        assignCoachToClient(clientId, newCoachId);
        
        const newCoach = coachLookupPool.find(c => c.id === newCoachId);
        const client = [...(pendingApprovals || []), ...(crmClients || [])].find(c => c.id === clientId);
        
        if (newCoach && client) {
            const coachInitial =
                resolveCoachInitialLetter(newCoach.name, team) ||
                newCoach.name.charAt(0).toUpperCase();
            const oldNr = client.mandantNr || client.clientData?.mandantNr || '';
            const coreNr = extractCoreNumber(oldNr);
            const isLegacyClient = !!(client.isLegacy || client.clientData?.isLegacy);
            
            let updatePayload: any = {
                'betreuer': newCoachId,
                'coachId': newCoachId,
                'coach': newCoachId,
                'clientData.betreuer': newCoachId,
                'clientData.coachId': newCoachId,
                'clientData.coach': newCoachId
            };
            
            // Vorabkunden: Nummer auf `MA NN/YYYY-X` mit neuem Coach-Initial normalisieren
            if (coreNr) {
                if (isLegacyClient) {
                    const newNr = normalizeVorabMandantNr(oldNr, coachInitial);
                    if (newNr) {
                        updatePayload['mandantNr'] = newNr;
                        updatePayload['clientData.mandantNr'] = newNr;
                        updatePayload['customerNumber'] = newNr;
                        updatePayload['clientData.customerNumber'] = newNr;
                    }
                } else {
                    const newNr = migrateMandantNrIfNeeded({
                        existingNr: oldNr,
                        isLegacy: false,
                        core: coreNr,
                        coachInitial,
                        client,
                        settings,
                        forceSoloTarif: !!client.forceSoloTarif || !!client.clientData?.forceSoloTarif,
                        isSolo: typeof client.isSolo === 'boolean' ? client.isSolo : undefined,
                        hasEmployeeEval: typeof client.hasEmployeeEval === 'boolean' ? client.hasEmployeeEval : undefined,
                    });
                    if (newNr) {
                        updatePayload['mandantNr'] = newNr;
                        updatePayload['clientData.mandantNr'] = newNr;
                    }
                }
            }
            
            try {
                await adminUpdateMandantRoot(clientId, updatePayload);
                fetchClients(); 
            } catch(err) {
                console.error("Konnte Coach und MandantNr nicht updaten", err);
            }
        }
        showNotification('Coach erfolgreich zugewiesen & gespeichert!', 'success');
    };

    const safeApprovals = (pendingApprovals || []).filter(c => !c.isArchived && !(c as any).isDeleted && (c as any).isActive !== false);
    const safeCrmClientsTemp = (crmClients || []).filter(c => !c.isArchived && !(c as any).isDeleted && (c as any).isActive !== false);
    const safeAdminTeam = useMemo(
        () => (team.length > 0 ? team : (adminTeam || [])),
        [team, adminTeam]
    );
    const coachLookupPool = useMemo(
        () => mergeTeamPool(safeAdminTeam, teamRegistry),
        [safeAdminTeam, teamRegistry]
    );
    const assignableTeam = useMemo(
        () => getAssignableTeam(safeAdminTeam),
        [safeAdminTeam]
    );
    const recruitableMembers = useMemo(() => {
        const activeIds = new Set(safeAdminTeam.map(m => m.id));
        return (teamRegistry || []).filter(m => m?.id && !activeIds.has(m.id));
    }, [teamRegistry, safeAdminTeam]);

    const myMember = useMemo(() => {
        const email = (auth.currentUser?.email || '').toLowerCase();
        if (!email) return null;
        const pool = [...(team || []), ...(teamRegistry || [])];
        const found = pool.find((m) => m?.email && String(m.email).toLowerCase() === email);
        if (found?.id) return found;
        if (portalRoleInfo.id) return { id: portalRoleInfo.id, email, name: '' };
        return null;
    }, [team, teamRegistry, portalRoleInfo.id]);

    const filteredCrmClients = safeCrmClientsTemp.filter((client: PendingClient) => {
        if (showInactive) {
            if (client.isLegacy || client.clientData?.isLegacy) return false;
            const rootYears = Array.isArray(client.geschaeftsjahre) ? client.geschaeftsjahre : [];
            const nestedYears = Array.isArray(client.clientData?.geschaeftsjahre) ? client.clientData.geschaeftsjahre : [];
            const years = rootYears.length ? rootYears : nestedYears;
            if (!years.length) return false;
            const latestStatus = String(years[years.length - 1]?.status || '');
            if (latestStatus !== 'datenerfassung') return false;
        }
        if (showOnlyMine) {
            if (!myMember?.id) return false;
            if (!clientMatchesMember(client, myMember, team, teamRegistry)) return false;
        }
        if (searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase();
            const firmennameMatch = (client.firmenname || client.clientData?.salonname || '').toLowerCase().includes(term);
            const mandantNrMatch = (client.mandantNr || client.clientData?.mandantNr || '').toLowerCase().includes(term);
            const nameMatch = `${client.vorname || ''} ${client.nachname || ''}`.toLowerCase().includes(term);
            if (!firmennameMatch && !mandantNrMatch && !nameMatch) return false;
        }
        return true;
    }).sort((a, b) => {
        const nameA = `${a.vorname || ''} ${a.nachname || ''}`.trim().toLowerCase();
        const nameB = `${b.vorname || ''} ${b.nachname || ''}`.trim().toLowerCase();
        return nameA.localeCompare(nameB, 'de');
    });

    if (!isInitialized) return null;

    if (!canAccessAdminPortal) {
        return null;
    }

    return (
        <div className="min-h-screen bg-pe-bg text-pe-text font-sans flex flex-col relative overflow-hidden">
            {auth.currentUser?.email?.toLowerCase() === 'erfolg@friseur-coaching.de' && (
                <GlobalBackupManager showNotification={showNotification} variant="guardian" />
            )}

            {showInvoiceModal && (
                <InvoiceCreatorModal
                    isOpen={showInvoiceModal}
                    onClose={() => setShowInvoiceModal(false)}
                    pendingRegistrationsCount={pendingSeminarRegsCount}
                />
            )}

            {showNewsletterModal && (
                <AdminNewsletterModal isOpen={showNewsletterModal} onClose={() => setShowNewsletterModal(false)} />
            )}

            {showEventModal && (
                <EventAdminModal isOpen={showEventModal} onClose={() => setShowEventModal(false)} />
            )}

            {showIntakeHub && (
                <IntakeHubModal adminMode onClose={() => setShowIntakeHub(false)} />
            )}

            {duplicateWarningOpen && (
                <div className="fixed inset-0 z-[100001] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-red-500/50 rounded-2xl p-8 max-w-md w-full shadow-[0_0_50px_rgba(220,38,38,0.3)] animate-fade-in relative">
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4">
                                <ShieldAlertIcon size={32} className="text-red-500" />
                            </div>
                            <h2 className="text-xl font-black text-pe-text tracking-widest uppercase mb-2">Doppelgänger erkannt!</h2>
                            <p className="text-sm text-slate-440">Ein Mandant mit dem Namen <strong className="text-pe-text">{vorabData.salonname}</strong> oder der Nummer <strong className="text-pe-text">{vorabData.mandantNr}</strong> existiert bereits im System.</p>
                        </div>
                        <div className="flex gap-4 w-full">
                            <button onClick={() => setDuplicateWarningOpen(false)} className="flex-1 bg-pe-card hover:bg-pe-hover text-pe-text font-bold uppercase tracking-widest text-xs py-3 rounded-xl transition-colors border border-pe-border-strong">
                                Abbrechen
                            </button>
                            <button onClick={() => handleSaveVorabkunde(true)} disabled={isSavingVorab} className={`flex-1 ${isSavingVorab ? 'bg-red-800' : 'bg-red-600 hover:bg-red-500'} text-white font-black uppercase tracking-widest text-xs py-3 rounded-xl transition-colors shadow-lg shadow-red-900/50 border border-red-500`}>
                                {isSavingVorab ? 'Speichere...' : 'Trotzdem anlegen'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showFilialModal && (
                <div className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-emerald-500/40 rounded-2xl p-8 max-w-lg w-full shadow-[0_0_50px_rgba(16,185,129,0.15)] animate-fade-in relative max-h-[90vh] overflow-y-auto">
                        <button
                            type="button"
                            onClick={() => setShowFilialModal(false)}
                            disabled={isSavingFilialen}
                            className="absolute top-4 right-4 text-pe-muted hover:text-pe-text"
                        >
                            <XIcon size={20} />
                        </button>
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-emerald-500/10 rounded-full flex items-center justify-center mb-4 border border-emerald-500/20">
                                <BuildingIcon size={28} className="text-emerald-400" />
                            </div>
                            <h3 className="text-xl font-black text-pe-text uppercase tracking-widest">Filialbetrieb</h3>
                            <p className="text-pe-muted text-sm mt-2">
                                Filiale 1 bleibt der Hauptsalon. Weitere Filialen bekommen eigene Kalkulationsakten.
                            </p>
                        </div>
                        <div className="space-y-3 mb-6">
                            {filialDraft.map((branch, idx) => (
                                <div key={branch.id} className="bg-pe-bg border border-pe-border-strong rounded-xl p-4 text-left">
                                    <div className="flex items-center justify-between gap-2 mb-2">
                                        <span className="text-[10px] font-black uppercase tracking-widest text-emerald-400">
                                            {branch.isMain ? 'Filiale 1 · Hauptsalon' : `Filiale ${idx + 1}`}
                                        </span>
                                        {!branch.isMain && (
                                            <button
                                                type="button"
                                                disabled={isSavingFilialen}
                                                onClick={() => setFilialDraft((prev) => prev.filter((b) => b.id !== branch.id))}
                                                className="text-[10px] text-red-400 hover:text-red-300 font-bold uppercase"
                                            >
                                                Entfernen
                                            </button>
                                        )}
                                    </div>
                                    <input
                                        type="text"
                                        value={branch.name}
                                        disabled={isSavingFilialen}
                                        onChange={(e) => setFilialDraft((prev) => prev.map((b) => b.id === branch.id ? { ...b, name: e.target.value } : b))}
                                        placeholder={branch.isMain ? 'z. B. Hauptsalon' : 'z. B. Filiale Nord'}
                                        className="w-full bg-pe-input border border-pe-border-strong rounded-lg px-3 py-2 text-pe-text text-sm outline-none focus:border-emerald-500"
                                    />
                                </div>
                            ))}
                        </div>
                        <button
                            type="button"
                            disabled={isSavingFilialen}
                            onClick={addFilialeToDraft}
                            className="w-full mb-4 px-4 py-3 rounded-xl border border-dashed border-emerald-500/50 text-emerald-300 hover:bg-emerald-500/10 text-xs font-black uppercase tracking-widest flex items-center justify-center gap-2"
                        >
                            <PlusIcon size={16} /> Filiale hinzufügen
                        </button>
                        <div className="flex gap-3">
                            <button
                                type="button"
                                disabled={isSavingFilialen}
                                onClick={() => setShowFilialModal(false)}
                                className="flex-1 px-4 py-3 rounded-xl border border-pe-border-strong text-pe-muted text-xs font-bold uppercase tracking-widest"
                            >
                                Abbrechen
                            </button>
                            <button
                                type="button"
                                disabled={isSavingFilialen}
                                onClick={saveFilialBetrieb}
                                className="flex-1 px-4 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-black uppercase tracking-widest disabled:opacity-60"
                            >
                                {isSavingFilialen ? 'Speichern…' : 'Speichern'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showVorabModal && (
                <div className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-blue-500/50 rounded-2xl p-8 max-w-lg w-full shadow-[0_0_50px_rgba(59,130,246,0.2)] animate-fade-in relative">
                        <button onClick={() => {setShowVorabModal(false); setDuplicateWarningOpen(false);}} disabled={isSavingVorab} className="absolute top-4 right-4 text-pe-muted hover:text-pe-text"><XIcon size={20}/></button>
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-4 border border-blue-500/20">
                                <UsersIcon size={32} className="text-blue-400" />
                            </div>
                            <h2 className="text-xl font-black text-pe-text tracking-widest uppercase mb-1">Neuer Vorab-Kunde</h2>
                            <p className="text-xs text-pe-muted">Erstellt eine "Legacy" Akte im System, um den Mandanten für Coach-Abrechnungen verfügbar zu machen.</p>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Vorname</label>
                                <input type="text" value={vorabData.vorname} onChange={e => setVorabData({...vorabData, vorname: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none" />
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Nachname</label>
                                <input type="text" value={vorabData.nachname} onChange={e => setVorabData({...vorabData, nachname: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none" />
                            </div>
                            <div className="col-span-2">
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Firma / Salonname *</label>
                                <input type="text" value={vorabData.salonname} onChange={e => setVorabData({...vorabData, salonname: e.target.value})} className="w-full bg-pe-bg border border-blue-500/30 text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none" />
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">E-Mail Adresse</label>
                                <input type="email" value={vorabData.mailadresse} onChange={e => setVorabData({...vorabData, mailadresse: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none" />
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Mandant-Nummer (z.B. 31/2023) *</label>
                                <input type="text" value={vorabData.mandantNr} onChange={e => setVorabData({...vorabData, mandantNr: e.target.value})} placeholder="z.B. 31/2023 → wird MA 31/2023-M" className="w-full bg-pe-bg border border-blue-500/30 text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none font-mono" />
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Coach / Betreuer</label>
                                <select value={vorabData.betreuer} onChange={e => setVorabData({...vorabData, betreuer: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-accent-text rounded p-2 text-sm focus:border-blue-500 outline-none cursor-pointer">
                                    <option value="">(Kein Betreuer)</option>
                                    {assignableTeam.map(c => (
                                        <option key={c.id} value={c.id}>{c.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Zugang ab (Monat) *</label>
                                <input
                                    type="month"
                                    value={vorabData.zugangAb}
                                    onChange={e => setVorabData({...vorabData, zugangAb: e.target.value})}
                                    className="w-full bg-pe-bg border border-blue-500/30 text-pe-text rounded p-2 text-sm focus:border-blue-500 outline-none"
                                />
                            </div>
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Monatsbeitrag (Fix)</label>
                                <input type="text" value={vorabData.monatsbeitrag} onChange={e => setVorabData({...vorabData, monatsbeitrag: e.target.value})} placeholder="0,00" className="w-full bg-pe-bg border border-pe-border-strong text-pe-accent-text rounded p-2 text-sm focus:border-blue-500 outline-none font-mono" />
                            </div>
                        </div>
                        <button onClick={() => handleSaveVorabkunde(false)} disabled={isSavingVorab} className={`w-full ${isSavingVorab ? 'bg-blue-800' : 'bg-blue-600 hover:bg-blue-500'} text-white font-black tracking-widest uppercase py-3 rounded-lg transition-colors mt-4`}>
                            {isSavingVorab ? 'Speichere...' : 'Vorabkunde anlegen'}
                        </button>
                    </div>
                </div>
            )}

            {showCancelModal && cancelClient && (
                <div className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-orange-500/50 rounded-2xl p-8 max-w-md w-full shadow-[0_0_50px_rgba(249,115,22,0.2)] animate-fade-in relative">
                        <button onClick={() => {setShowCancelModal(false); setCancelClient(null); setCancelMonth('');}} disabled={isProcessingAction} className="absolute top-4 right-4 text-pe-muted hover:text-pe-text"><XIcon size={20}/></button>
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-orange-500/10 rounded-full flex items-center justify-center mb-4 border border-orange-500/20">
                                <ArchiveIcon size={32} className="text-orange-500" />
                            </div>
                            <h2 className="text-xl font-black text-pe-text tracking-widest uppercase mb-1">Kündigung einleiten</h2>
                            <p className="text-sm text-pe-muted font-bold mb-2">{cancelClient.firmenname || cancelClient.vorname}</p>
                            <p className="text-xs text-pe-muted">Wähle den Monat, zu dessen Ende der Mandant ausscheidet. Liegt das Monatsende in der Vergangenheit, wird die Akte <span className="text-orange-400 font-bold">sofort archiviert</span>.</p>
                        </div>
                        <div className="space-y-6">
                            <div>
                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-2 block text-center">Letzter aktiver Monat</label>
                                <input 
                                    type="month" 
                                    value={cancelMonth} 
                                    onChange={(e) => setCancelMonth(e.target.value)} 
                                    className="w-full bg-pe-bg border border-orange-500/30 text-pe-text rounded-lg px-4 py-3 text-center tracking-widest font-mono focus:border-orange-500 outline-none" 
                                />
                            </div>
                            <button 
                                onClick={handleCancelSubmit} 
                                disabled={isProcessingAction || !cancelMonth} 
                                className={`w-full ${isProcessingAction || !cancelMonth ? 'bg-pe-card text-pe-muted cursor-not-allowed' : 'bg-orange-600 hover:bg-orange-500 text-white'} font-black tracking-widest uppercase py-3 rounded-lg transition-colors`}
                            >
                                {isProcessingAction ? 'Verarbeite...' : 'Kündigung bestätigen'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showDeleteYearModal && yearToDelete && (
                <div className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-red-500/50 rounded-2xl p-8 max-w-md w-full shadow-[0_0_50px_rgba(220,38,38,0.3)] animate-fade-in relative">
                        <button onClick={() => {setShowDeleteYearModal(false); setYearToDelete(null); setDeleteYearCode(''); setDeleteYearError(false);}} className="absolute top-4 right-4 text-pe-muted hover:text-pe-text"><XIcon size={20}/></button>
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4">
                                <TrashIcon size={32} className="text-red-500" />
                            </div>
                            <h2 className="text-xl font-black text-pe-text tracking-widest uppercase mb-2">Jahr {yearToDelete} vernichten</h2>
                            <p className="text-xs text-pe-muted">Dies löscht das Geschäftsjahr <span className="font-bold text-red-400">{yearToDelete}</span> inkl. PDF-Datei restlos aus der Datenbank. Die Aktion ist endgültig. Bitte tippen Sie zur Bestätigung <strong>{yearToDelete}</strong> in das Feld.</p>
                        </div>
                        <div className="space-y-4">
                            <input 
                                type="text" 
                                value={deleteYearCode} 
                                onChange={(e) => {setDeleteYearCode(e.target.value); setDeleteYearError(false);}} 
                                placeholder={String(yearToDelete)} 
                                className="w-full bg-pe-bg border border-red-500/30 text-pe-text rounded-lg px-4 py-3 text-center tracking-widest font-mono focus:border-red-500 outline-none" 
                                autoFocus 
                            />
                            {deleteYearError && <p className="text-red-500 text-xs text-center font-bold animate-pulse">FALSCHER BESTÄTIGUNGSCODE.</p>}
                            <button 
                                onClick={() => {
                                    if (deleteYearCode === String(yearToDelete)) {
                                        handleDeleteYear();
                                    } else {
                                        setDeleteYearError(true);
                                    }
                                }} 
                                disabled={isProcessingAction} 
                                className={`w-full ${isProcessingAction ? 'bg-red-800' : 'bg-red-600 hover:bg-red-500'} text-white font-black tracking-widest uppercase py-3 rounded-lg transition-colors`}
                            >
                                {isProcessingAction ? 'Wird gelöscht...' : 'Endgültig löschen'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {selectedAkte && (
                <>
                    <div 
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] transition-opacity"
                        onClick={() => setSelectedAkte(null)}
                    />
                    
                    <div className="fixed inset-y-0 right-0 w-full max-w-4xl bg-pe-elevated z-[101] shadow-2xl border-l border-pe-border flex flex-col transform transition-transform duration-300 animate-slide-in-right">
                        
                        <div className="flex items-center justify-between p-6 border-b border-pe-border bg-pe-card">
                            <div>
                                <div className="text-pe-accent-text text-[10px] font-black uppercase tracking-widest mb-1 flex items-center gap-2">
                                    <BriefcaseIcon size={12} /> Mandanten-Akte
                                    {selectedAkte.isLegacy && (
                                        <span className="ml-2 bg-blue-100 text-blue-900 border border-blue-400 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/30 px-1.5 py-0.5 rounded text-[8px] uppercase tracking-widest font-black shrink-0">Vorabkunde</span>
                                    )}
                                </div>
                                <h2 className="text-2xl font-bold text-pe-text">
                                    {selectedAkte.vorname} {selectedAkte.nachname}
                                </h2>
                                
                                <div className="flex items-center gap-3 mt-2">
                                    <span className="text-pe-accent-text text-xs font-bold uppercase tracking-widest">
                                        {selectedAkte.firmenname || selectedAkte.clientData?.salonname || 'Kein Salonname'}
                                    </span>
                                    <span className="text-pe-muted text-xs">|</span>
                                    {(() => {
                                        const raw = String(selectedAkte.mandantNr || selectedAkte.clientData?.mandantNr || '').trim();
                                        if (!raw) {
                                            return (
                                                <span className="text-pe-muted text-xs font-mono bg-pe-card px-2 py-0.5 rounded border border-pe-border-strong shadow-inner">
                                                    Wartet auf Mandant-Nummer...
                                                </span>
                                            );
                                        }
                                        const letter = resolveCoachInitialLetter(
                                            resolveClientCoach(selectedAkte, coachLookupPool)?.name ||
                                                selectedAkte.betreuer ||
                                                selectedAkte.coachId,
                                            coachLookupPool
                                        );
                                        const shown =
                                            selectedAkte.isLegacy || selectedAkte.clientData?.isLegacy
                                                ? normalizeVorabMandantNr(raw, letter) || formatMandantNrDisplay(raw, letter) || raw
                                                : formatMandantNrDisplay(raw, letter) || raw;
                                        return (
                                            <MandantNrPill
                                                displayNr={shown}
                                                betreuer={
                                                    resolveClientCoach(selectedAkte, coachLookupPool)?.name ||
                                                    selectedAkte.betreuer ||
                                                    selectedAkte.coachId
                                                }
                                                team={coachLookupPool}
                                                size="sm"
                                            />
                                        );
                                    })()}
                                    <span className="text-pe-muted text-xs">|</span>
                                    <span className="text-pe-muted text-[10px] font-mono" title="Firebase Datenbank ID">
                                        DB-ID: {selectedAkte.id}
                                    </span>
                                </div>
                            </div>
                            <button onClick={() => setSelectedAkte(null)} className="p-2 bg-pe-card hover:bg-pe-hover rounded-full text-pe-muted transition-colors">
                                <XIcon size={24} />
                            </button>
                        </div>

                        <div className="flex px-6 border-b border-pe-border bg-pe-card overflow-x-auto">
                            <button 
                                onClick={() => setDrawerTab('jahre')}
                                className={`px-6 py-4 text-sm font-bold uppercase tracking-widest border-b-2 transition-colors whitespace-nowrap ${drawerTab === 'jahre' ? 'border-[#E6C299] text-pe-accent-text' : 'border-transparent text-pe-muted hover:text-pe-muted'}`}
                            >
                                Geschäftsjahre (Login)
                            </button>
                            <button 
                                onClick={() => setDrawerTab('stammdaten')}
                                className={`px-6 py-4 text-sm font-bold uppercase tracking-widest border-b-2 transition-colors whitespace-nowrap ${drawerTab === 'stammdaten' ? 'border-[#E6C299] text-pe-accent-text' : 'border-transparent text-pe-muted hover:text-pe-muted'}`}
                            >
                                Stammdaten & Land
                            </button>
                            <button 
                                onClick={() => setDrawerTab('termine')}
                                className={`px-6 py-4 text-sm font-bold uppercase tracking-widest border-b-2 transition-colors whitespace-nowrap ${drawerTab === 'termine' ? 'border-[#E6C299] text-pe-accent-text' : 'border-transparent text-pe-muted hover:text-pe-muted'}`}
                            >
                                1:1 Termine
                            </button>
                        </div>

                        <div className="flex-1 overflow-y-auto p-6 md:p-8">
                            
                            {drawerTab === 'jahre' && (
                                <div className="space-y-6">
                                    <div className="bg-blue-900/10 border border-blue-500/20 p-4 rounded-xl flex gap-4">
                                        <ShieldCheckIcon className="text-blue-400 shrink-0" size={24} />
                                        <p className="text-sm text-pe-muted leading-relaxed">
                                            Wählen Sie das Jahr aus, das Sie bearbeiten möchten. Sie loggen sich damit virtuell als der Mandant ein <strong>(God-Mode)</strong> und haben Vollzugriff auf alle seine Kalkulationsdaten.
                                        </p>
                                    </div>

                                    <div className="bg-pe-card border border-[#E6C299]/25 rounded-xl p-5 flex flex-col md:flex-row md:items-end gap-4">
                                        <div className="flex-1">
                                            <h4 className="text-sm font-black text-pe-accent-text uppercase tracking-widest mb-1">Geschäftsjahr dieser Akte setzen</h4>
                                            <p className="text-xs text-pe-muted leading-relaxed">
                                                Nur für <strong className="text-pe-text">diesen Mandanten</strong>.
                                                Bei einem einzigen Jahr wird umbenannt; existiert das Zieljahr schon, wird es aktiv gesetzt.
                                                Fehlt es bei mehreren Jahren, erscheint eine starke Warnung — Stammdaten-Speichern legt nie still ein neues Jahr an.
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-3 shrink-0">
                                            <select
                                                value={akteZielJahr}
                                                onChange={(e) => setAkteZielJahr(Number(e.target.value))}
                                                className="bg-pe-bg border border-pe-border-strong text-pe-text font-mono font-bold text-sm rounded-lg px-4 py-2.5 focus:outline-none focus:border-[#E6C299]/50"
                                            >
                                                {[2025, 2026, 2027, 2028].map((y) => (
                                                    <option key={y} value={y}>{y}</option>
                                                ))}
                                            </select>
                                            <button
                                                type="button"
                                                disabled={isSettingAkteJahr}
                                                onClick={handleSetAkteGeschaeftsjahr}
                                                className="px-4 py-2.5 bg-[#E6C299] hover:bg-white text-black font-black uppercase tracking-widest text-[10px] rounded-lg transition-colors disabled:opacity-50"
                                            >
                                                {isSettingAkteJahr ? 'Speichert…' : 'Für diese Akte setzen'}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {selectedAkte.geschaeftsjahre && selectedAkte.geschaeftsjahre.length > 0 ? (
                                            selectedAkte.geschaeftsjahre.map((jahrItem: any, index: number) => (
                                                <div key={index} className="bg-pe-card border border-pe-border-strong rounded-xl p-6 flex flex-col items-center text-center hover:border-[#E6C299]/50 transition-colors group">
                                                    <CalendarIcon size={32} className="text-pe-accent-text mb-3 group-hover:scale-110 transition-transform" />
                                                    <h3 className="text-2xl font-black text-pe-text mb-1">{jahrItem.jahr}</h3>
                                                    <span className="text-[10px] uppercase tracking-widest font-bold text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded mb-6">
                                                        Status: {jahrItem.status || 'Aktiv'}
                                                    </span>
                                                    
                                                    <div className="flex w-full gap-2">
                                                        <button 
                                                            onClick={() => {
                                                                sessionStorage.setItem('CURRENT_YEAR', jahrItem.jahr.toString());
                                                                // Archiviert = Panzerglas; sonst Jahr-Status, aber 'abgeschlossen' für God-Mode-Arbeit öffnen
                                                                if (selectedAkte.isArchived) {
                                                                    localStorage.setItem('CURRENT_YEAR_STATUS', 'abgeschlossen');
                                                                } else {
                                                                    const st = jahrItem.status || 'datenerfassung';
                                                                    localStorage.setItem(
                                                                        'CURRENT_YEAR_STATUS',
                                                                        st === 'abgeschlossen' ? 'datenerfassung' : st
                                                                    );
                                                                }
                                                                startImpersonation(selectedAkte.id, selectedAkte.firmenname || selectedAkte.vorname || 'Unbekannt');
                                                            }}
                                                            className="flex-1 bg-[#E6C299] hover:bg-white text-black font-black uppercase tracking-widest py-3 rounded-lg transition-colors text-[10px]"
                                                        >
                                                            Einloggen
                                                        </button>
                                                        <button 
                                                            onClick={() => {
                                                                setYearToDelete(jahrItem.jahr);
                                                                setShowDeleteYearModal(true);
                                                            }}
                                                            className="px-4 bg-red-900/30 hover:bg-red-600 text-red-500 hover:text-white border border-red-500/30 hover:border-red-500 font-black uppercase tracking-widest rounded-lg transition-colors flex items-center justify-center shadow-lg"
                                                            title={`Jahr ${jahrItem.jahr} restlos löschen`}
                                                        >
                                                            <TrashIcon size={14} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="col-span-2 bg-pe-hover border border-pe-border-strong border-dashed rounded-xl p-12 flex flex-col items-center text-center">
                                                <CalendarIcon size={48} className="text-pe-muted mb-4" />
                                                <h3 className="text-xl font-bold text-pe-text mb-2">Noch keine Geschäftsjahre vorhanden</h3>
                                                <p className="text-pe-muted text-sm max-w-md">Dieser Mandant hat noch keinen Jahres-Zyklus gestartet. Sie können dennoch im Basis-Modus die Akte öffnen.</p>
                                                <button 
                                                    onClick={() => {
                                                        if (selectedAkte.isArchived) {
                                                            localStorage.setItem('CURRENT_YEAR_STATUS', 'abgeschlossen');
                                                        } else {
                                                            localStorage.setItem('CURRENT_YEAR_STATUS', 'datenerfassung');
                                                        }
                                                        startImpersonation(selectedAkte.id, selectedAkte.firmenname || selectedAkte.vorname || 'Unbekannt');
                                                    }}
                                                    className="mt-6 bg-pe-card hover:bg-[#E6C299] text-pe-text hover:text-black font-black uppercase tracking-widest px-6 py-3 rounded-lg transition-colors text-xs"
                                                >
                                                    Basis-Akte öffnen
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    {/* Letzte Änderungen / Chronik (Änderungszentrale Coach-Locks) */}
                                    <div className="mt-8 bg-pe-bg border border-pe-border rounded-xl p-5">
                                        <h4 className="text-sm font-black text-pe-accent-text uppercase tracking-widest mb-1 flex items-center gap-2">
                                            <ActivityIcon size={14} className="text-pe-accent-text" />
                                            Letzte Änderungen / Chronik
                                        </h4>
                                        <p className="text-[10px] text-pe-muted mb-4">
                                            Einträge aus der Änderungszentrale (gesperrt durch Coach).
                                        </p>
                                        {(() => {
                                            const raw =
                                                selectedAkte?.clientData?.aenderungsChronik ||
                                                selectedAkte?.aenderungsChronik ||
                                                [];
                                            const seen = new Set<string>();
                                            const unique = (Array.isArray(raw) ? raw : []).filter((e: any) => {
                                                const key = `${e?.createdAt || ''}|${e?.authorName || ''}|${e?.description || ''}|${e?.draftId || ''}|${e?.category || ''}`;
                                                if (seen.has(key)) return false;
                                                seen.add(key);
                                                return true;
                                            });
                                            const entries = [...unique].reverse();
                                            if (entries.length === 0) {
                                                return (
                                                    <p className="text-xs text-pe-muted italic py-2">
                                                        Keine eingetragenen Änderungen vorhanden
                                                    </p>
                                                );
                                            }
                                            return (
                                                <ul className="space-y-2 max-h-64 overflow-y-auto pr-1">
                                                    {entries.map((entry: any, idx: number) => (
                                                        <li
                                                            key={`${entry?.createdAt || 'd'}-${entry?.authorName || 'a'}-${entry?.draftId || idx}-${idx}`}
                                                            className="text-sm text-pe-muted border-b border-pe-border/60 pb-2 last:border-0 last:pb-0"
                                                        >
                                                            <span className="font-mono text-pe-muted text-xs">
                                                                {entry?.createdAt || '—'}
                                                            </span>
                                                            <span className="text-pe-muted mx-1.5">|</span>
                                                            <span className="font-bold text-pe-accent-text">
                                                                {entry?.authorName || 'Unbekannt'}
                                                            </span>
                                                            <span className="text-pe-muted">: </span>
                                                            <span className="text-pe-muted">
                                                                {entry?.description || '—'}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            );
                                        })()}
                                    </div>

                                    <div className="mt-10 pt-6 border-t border-pe-border">
                                        <div className="bg-yellow-500/5 border border-yellow-500/20 rounded-xl p-6 flex flex-col md:flex-row items-center justify-between gap-6">
                                            <div>
                                                <h4 className="text-pe-text font-bold mb-1 flex items-center gap-2">
                                                    <ActivityIcon size={16} className="text-yellow-500"/> System Setup & Onboarding
                                                </h4>
                                                <p className="text-pe-muted text-xs">
                                                    Fehlt die BWA oder das Paket? Springe als Admin direkt in den Onboarding-Prozess dieses Mandanten, um Daten nachzutragen oder den Setup-Prozess abzuschließen.
                                                </p>
                                            </div>
                                            <button 
                                                onClick={() => {
                                                    window.history.pushState({}, '', '/onboarding');
                                                    if (selectedAkte.isArchived) {
                                                        localStorage.setItem('CURRENT_YEAR_STATUS', 'abgeschlossen');
                                                    } else {
                                                        localStorage.setItem('CURRENT_YEAR_STATUS', 'datenerfassung');
                                                    }
                                                    startImpersonation(selectedAkte.id, selectedAkte.firmenname || selectedAkte.vorname || 'Unbekannt');
                                                }}
                                                className="whitespace-nowrap bg-pe-card hover:bg-pe-hover text-yellow-500 border border-yellow-500/30 font-bold uppercase tracking-widest px-6 py-3 rounded-lg transition-colors text-xs flex justify-center items-center gap-2 shadow-lg"
                                            >
                                                <ExternalLinkIcon size={14}/> INS ONBOARDING EINLOGGEN
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {drawerTab === 'stammdaten' && (
                                <div className="space-y-8 animate-fade-in pb-24">
                                    
                                    <div className="bg-blue-900/10 border border-blue-500/30 rounded-xl p-6">
                                        <h3 className="text-sm font-black text-blue-400 uppercase tracking-widest mb-4 flex items-center gap-2">
                                            <ShieldCheckIcon size={16} /> System-Identifikation
                                        </h3>
                                        <div className="space-y-2">
                                            <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider block">Mandant-Basisnummer (MM/JJJJ = Zugangsmonat)</label>
                                            <input
                                                type="text"
                                                value={stammdatenEdit.coreMandantNr || ''}
                                                onChange={(e) => {
                                                    const raw = e.target.value;
                                                    const normalized = String(raw).replace(/(\d{2})\.(\d{4})/g, '$1/$2');
                                                    const core = normalized.trim();
                                                    setStammdatenEdit((prev: any) => {
                                                        let next: any = { ...prev, coreMandantNr: raw };
                                                        if (isValidMonthYearCore(core)) {
                                                            const [mm, yyyy] = core.split('/');
                                                            next.coreMandantNr = core;
                                                            next.vertragsbeginn = `${yyyy}-${mm}`;
                                                            // Jahr in der Nummer steuert das Neukunden-Häkchen automatisch
                                                            next = syncNeukundenFromNummer(next);
                                                        }
                                                        return next;
                                                    });
                                                }}
                                                placeholder="z.B. 08/2026"
                                                className="w-full max-w-xs bg-pe-bg border border-pe-border-strong rounded-lg p-3 text-xl font-mono text-pe-text font-bold focus:border-blue-500 outline-none"
                                            />
                                            
                                            <div className="bg-blue-950/30 border border-blue-900/50 p-3 rounded-lg mt-3">
                                                <span className="text-[10px] text-pe-muted uppercase font-bold tracking-widest block mb-1">Daraus resultierende System-ID:</span>
                                                <span className="text-sm font-mono text-blue-400 font-bold">
                                                    {(() => {
                                                        const tier = resolveTarifTier({
                                                            settings,
                                                            client: selectedAkte,
                                                            forceSoloTarif: !!stammdatenEdit.forceSoloTarif,
                                                            isSolo: !!stammdatenEdit.isSolo || !!stammdatenEdit.forceSoloTarif,
                                                            hasEmployeeEval: !!stammdatenEdit.hasEmployeeEval,
                                                            lizenzTyp: stammdatenEdit.lizenzTyp,
                                                        });
                                                        return buildMandantNr({
                                                            core: stammdatenEdit.coreMandantNr || 'XX/XXXX',
                                                            coachInitial: stammdatenEdit.coachInitial || null,
                                                            tarifStatus: tarifStatusFromTier(tier),
                                                        });
                                                    })()}
                                                </span>
                                            </div>
                                            <p className="text-[10px] text-pe-muted mt-2 italic leading-tight">
                                                Hier steht der Zugangsmonat (01–12), nicht die laufende Mandant-Nummer. Änderung auf 08/2026 setzt Start und Verlängerung auf 08.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="bg-emerald-900/10 border border-emerald-500/30 rounded-xl p-6">
                                        <h3 className="text-sm font-black text-emerald-400 uppercase tracking-widest mb-3 flex items-center gap-2">
                                            <BuildingIcon size={16} /> Filialbetrieb
                                        </h3>
                                        <p className="text-[11px] text-pe-muted mb-4 leading-relaxed">
                                            {stammdatenEdit.hasBranches
                                                ? `${(stammdatenEdit.branches || []).length || 0} Filiale(n) aktiv — jede weitere Filiale erhält eine eigene Kalkulationsakte.`
                                                : 'Einzelbetrieb. Aktiviere den Filialbetrieb, um weitere Standorte mit eigener Kalkulation anzulegen.'}
                                        </p>
                                        <button
                                            type="button"
                                            onClick={openFilialModal}
                                            className="w-full md:w-auto px-4 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-black uppercase tracking-widest border border-emerald-400/40"
                                        >
                                            {stammdatenEdit.hasBranches ? 'Filialen verwalten' : 'Filialbetrieb aktivieren'}
                                        </button>
                                    </div>

                                    <div className="bg-[#E6C299]/10 border border-[#E6C299]/30 rounded-xl p-6">
                                        <h3 className="text-sm font-black text-pe-accent-text uppercase tracking-widest mb-4 flex items-center gap-2">
                                            <MapPinIcon size={16} /> Steuer- & Länderparameter
                                        </h3>
                                        
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="space-y-2">
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider">Sitz des Unternehmens *</label>
                                                <select 
                                                    value={stammdatenEdit.land}
                                                    onChange={(e) => setStammdatenEdit({...stammdatenEdit, land: e.target.value})}
                                                    className="w-full bg-pe-bg border border-[#E6C299]/50 text-pe-text rounded-lg px-4 py-3 outline-none focus:border-[#E6C299] transition-colors font-bold"
                                                >
                                                    <option value="DE">Deutschland (DE)</option>
                                                    <option value="AT">Österreich (AT)</option>
                                                    <option value="CH">Schweiz (CH)</option>
                                                    <option value="IT">Italien / Südtirol (IT)</option>
                                                </select>
                                                <p className="text-[10px] text-pe-muted mt-2 italic leading-tight">
                                                    WICHTIG: Diese Einstellung steuert die Kalkulationsbasis. <br/>
                                                    <span className="text-pe-accent-text font-bold block mt-1">
                                                        ↳ System-Währung für diese Akte: {stammdatenEdit.land === 'CH' ? 'CHF (Fr.)' : 'EUR (€)'}
                                                    </span>
                                                </p>
                                            </div>

                                            <div className="space-y-2">
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider">Unternehmensform *</label>
                                                <select 
                                                    value={stammdatenEdit.unternehmensform}
                                                    onChange={(e) => setStammdatenEdit({...stammdatenEdit, unternehmensform: e.target.value})}
                                                    className="w-full bg-pe-bg border border-[#E6C299]/50 text-pe-text rounded-lg px-4 py-3 outline-none focus:border-[#E6C299] transition-colors font-bold"
                                                >
                                                    <option value="">Bitte auswählen</option>
                                                    <option value="Einzelunternehmen">Einzelunternehmen</option>
                                                    <option value="GbR">GbR</option>
                                                    <option value="GmbH">GmbH</option>
                                                    <option value="UG">UG</option>
                                                    <option value="Sonstige">Sonstige</option>
                                                    {stammdatenEdit.unternehmensform && !["", "Einzelunternehmen", "GbR", "GmbH", "UG", "Sonstige"].includes(stammdatenEdit.unternehmensform) && (
                                                        <option value={stammdatenEdit.unternehmensform}>{stammdatenEdit.unternehmensform} (Altbestand)</option>
                                                    )}
                                                </select>
                                                <p className="text-[10px] text-pe-muted mt-2 italic leading-tight">
                                                    Steuert u.a. die Berechnungslogik (z.B. GmbH Geschäftsführer-Gehalt).
                                                </p>
                                            </div>

                                            <div className="space-y-2 flex flex-col justify-center">
                                                <label className="flex items-start cursor-pointer group mt-2">
                                                    <div className="flex items-center h-6">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={stammdatenEdit.umsatzsteuerbefreit} 
                                                            onChange={(e) => setStammdatenEdit({...stammdatenEdit, umsatzsteuerbefreit: e.target.checked})} 
                                                            className="w-5 h-5 rounded border-pe-border-strong text-pe-accent-text focus:ring-[#E6C299] bg-pe-bg" 
                                                        />
                                                    </div>
                                                    <div className="ml-3">
                                                        <span className="text-sm font-bold text-pe-muted group-hover:text-pe-text transition-colors">Mandant ist Umsatzsteuerbefreit</span>
                                                        <p className="text-[10px] text-pe-muted mt-1">Gilt z.B. für Kleinunternehmer.</p>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-pe-hover border border-pe-border-strong/50 rounded-xl p-6">
                                        <h3 className="text-sm font-black text-blue-400 uppercase tracking-widest mb-4 flex items-center gap-2">
                                            <ShieldCheckIcon size={16} /> Lizenz-Modell (Tarif)
                                        </h3>
                                        
                                        <div className="flex bg-pe-bg rounded-lg p-1 border border-pe-border-strong relative mb-2 gap-1">
                                            {stammdatenEdit.lizenzTyp === '' && selectedAkte.isLegacy && (
                                                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-blue-900/80 text-blue-300 text-[9px] px-2 py-0.5 rounded-full border border-blue-700">Kein Paket zugewiesen</div>
                                            )}
                                            {(() => {
                                                const active = resolveEditTarif();
                                                return (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleTarifSelect('solo')}
                                                            className={`flex-1 py-3 text-xs font-bold tracking-widest rounded-md transition-all ${
                                                                active === 'solo'
                                                                    ? 'bg-purple-500/20 text-purple-300 border border-purple-500/40 shadow-md'
                                                                    : 'text-pe-muted hover:text-purple-300 border border-transparent'
                                                            }`}
                                                        >
                                                            Solo
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleTarifSelect('team')}
                                                            className={`flex-1 py-3 text-xs font-bold tracking-widest rounded-md transition-all ${
                                                                active === 'team'
                                                                    ? 'bg-[#E6C299]/20 text-pe-accent-text border border-[#E6C299]/40 shadow-md'
                                                                    : 'text-pe-muted hover:text-pe-accent-text border border-transparent'
                                                            }`}
                                                        >
                                                            Team
                                                        </button>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                        <p className="text-[10px] text-pe-muted mb-4 leading-tight">
                                            Solo = violett · Team = gold (Teamauswertung immer aktiv). Team-Plus entsteht automatisch über den Umsatz. Altbestand mit TeamBase wird als TEAM-BASE (Alt) angezeigt.
                                        </p>

                                        <label className="flex items-start cursor-pointer group mt-4 pt-4 border-t border-pe-border-strong/50">
                                            <div className="flex items-center h-6">
                                                <input
                                                    type="checkbox"
                                                    checked={!!stammdatenEdit.neukundenAufschlag}
                                                    onChange={(e) => handleNeukundenToggle(e.target.checked)}
                                                    className="w-5 h-5 rounded border-pe-border-strong text-blue-400 focus:ring-blue-400 bg-pe-bg"
                                                />
                                            </div>
                                            <div className="ml-3">
                                                <span className="text-sm font-bold text-blue-400 group-hover:text-blue-300 transition-colors">Neukunden-Aufschlag</span>
                                                <p className="text-[10px] text-pe-muted mt-1">
                                                    Automatisch an bei Jahr ≥ 2027 in der Basisnummer, sonst aus. Alte Akten folgen der Nummer sofort — manuell nur überschreiben, wenn wirklich eine Ausnahme nötig ist.
                                                </p>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="space-y-4">
                                        <h3 className="text-sm font-black text-pe-text uppercase tracking-widest border-b border-pe-border pb-2">Kontakt & Adresse</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Unternehmername</label>
                                                <input value={stammdatenEdit.unternehmername} onChange={(e) => setStammdatenEdit({...stammdatenEdit, unternehmername: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Salonname</label>
                                                <input value={stammdatenEdit.salonname} onChange={(e) => setStammdatenEdit({...stammdatenEdit, salonname: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">E-Mail</label>
                                                <input value={stammdatenEdit.mailadresse} onChange={(e) => setStammdatenEdit({...stammdatenEdit, mailadresse: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Telefon / WhatsApp</label>
                                                <input value={stammdatenEdit.whatsappNr} onChange={(e) => setStammdatenEdit({...stammdatenEdit, whatsappNr: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Salonnummer (Festnetz)</label>
                                                <input value={stammdatenEdit.salonFestnetz || ''} onChange={(e) => setStammdatenEdit({...stammdatenEdit, salonFestnetz: e.target.value})} placeholder="z.B. 040 / 123 456 78" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Filialname / Standortbezeichnung</label>
                                                <input value={stammdatenEdit.branchName || ''} onChange={(e) => setStammdatenEdit({...stammdatenEdit, branchName: e.target.value})} placeholder="z. B. Salon City oder Filiale Nord" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div className="md:col-span-2">
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Straße & Hausnummer</label>
                                                <input value={stammdatenEdit.strasse} onChange={(e) => setStammdatenEdit({...stammdatenEdit, strasse: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">PLZ</label>
                                                <input value={stammdatenEdit.plz} onChange={(e) => setStammdatenEdit({...stammdatenEdit, plz: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Ort</label>
                                                <input value={stammdatenEdit.ort} onChange={(e) => setStammdatenEdit({...stammdatenEdit, ort: e.target.value})} className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-4 mt-8 pt-8 border-t border-pe-border">
                                        <div className="flex justify-between items-center mb-4">
                                            <h3 className="text-sm font-black text-pe-accent-text uppercase tracking-widest flex items-center gap-2">
                                                <SettingsIcon size={16} /> Individuelle Kalkulations-Parameter
                                            </h3>
                                            <div className="flex items-center gap-2">
                                                <input 
                                                    type="file" 
                                                    accept=".json" 
                                                    ref={fileInputRef} 
                                                    style={{ display: 'none' }} 
                                                    onChange={handleJSONImport} 
                                                />
                                                <button 
                                                    type="button"
                                                    onClick={(e) => { e.preventDefault(); fileInputRef.current?.click(); }}
                                                    className="flex items-center gap-2 text-[10px] bg-blue-900/30 hover:bg-blue-800/50 text-blue-400 px-3 py-1.5 rounded border border-blue-800/50 transition-colors uppercase font-bold tracking-widest shadow-lg"
                                                >
                                                    <ArchiveIcon size={12} /> JSON Laden
                                                </button>
                                                <button 
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (window.confirm("Alle Parameter auf den Standard zurücksetzen?")) {
                                                            setStammdatenEdit((prev: any) => ({
                                                                ...prev,
                                                                ...DEFAULT_MANDANTEN_PARAMETER
                                                            }));
                                                        }
                                                    }}
                                                    className="flex items-center gap-2 text-[10px] bg-pe-card hover:bg-pe-hover text-pe-muted px-3 py-1.5 rounded border border-pe-border-strong transition-colors uppercase font-bold tracking-widest shadow-lg"
                                                >
                                                    <RefreshIcon size={12} /> Auf Standard setzen
                                                </button>
                                            </div>
                                        </div>

                                        <p className="text-[10px] text-pe-muted mb-4">
                                            Diese Parameter werden jahrgangsspezifisch gespeichert.
                                        </p>
                                        
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Wochensatz</label>
                                                <input type="text" value={stammdatenEdit.wochensatz} onChange={(e) => setStammdatenEdit({...stammdatenEdit, wochensatz: e.target.value})} placeholder="4,33" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Auslastungsfaktor (%)</label>
                                                <input type="text" value={stammdatenEdit.auslastungsfaktor} onChange={(e) => setStammdatenEdit({...stammdatenEdit, auslastungsfaktor: e.target.value})} placeholder="75" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Max. Auslastung (%)</label>
                                                <input type="text" value={stammdatenEdit.auslastungsfaktorMax} onChange={(e) => setStammdatenEdit({...stammdatenEdit, auslastungsfaktorMax: e.target.value})} placeholder="100" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Zusatzumsatz</label>
                                                <input type="text" value={stammdatenEdit.zusatzumsatz} onChange={(e) => setStammdatenEdit({...stammdatenEdit, zusatzumsatz: e.target.value})} placeholder="30" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Gewinnlinie (%)</label>
                                                <input type="text" value={stammdatenEdit.gewinnlinie} onChange={(e) => setStammdatenEdit({...stammdatenEdit, gewinnlinie: e.target.value})} placeholder="26" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Investlinie (%)</label>
                                                <input type="text" value={stammdatenEdit.investlinie} onChange={(e) => setStammdatenEdit({...stammdatenEdit, investlinie: e.target.value})} placeholder="5" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Verlust 1 (%)</label>
                                                <input type="text" value={stammdatenEdit.verlust1} onChange={(e) => setStammdatenEdit({...stammdatenEdit, verlust1: e.target.value})} placeholder="15" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Liquidität (%)</label>
                                                <input type="text" value={stammdatenEdit.liquiditaet} onChange={(e) => setStammdatenEdit({...stammdatenEdit, liquiditaet: e.target.value})} placeholder="10" className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-4 mt-8 pt-8 border-t border-pe-border">
                                        <h3 className="text-sm font-black text-pe-accent-text uppercase tracking-widest pb-2 flex items-center gap-2">
                                            <CalendarIcon size={16} /> Vertragsdaten & Abrechnung
                                        </h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Zugang ab / Vertragsbeginn</label>
                                                <input 
                                                    type="month" 
                                                    value={stammdatenEdit.vertragsbeginn} 
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setStammdatenEdit((prev: any) => {
                                                            let next: any = { ...prev, vertragsbeginn: value };
                                                            if (/^\d{4}-\d{2}$/.test(value)) {
                                                                const [y, m] = value.split('-');
                                                                const core = `${m}/${y}`;
                                                                const prevCore = String(prev.coreMandantNr || '')
                                                                    .trim()
                                                                    .replace(/(\d{2})\.(\d{4})/g, '$1/$2');
                                                                if (/^\d{2}\/\d{4}$/.test(prevCore) || !prevCore) {
                                                                    next.coreMandantNr = core;
                                                                    next = syncNeukundenFromNummer(next);
                                                                }
                                                            }
                                                            return next;
                                                        });
                                                    }} 
                                                    className="w-full bg-pe-bg border border-pe-border-strong text-pe-text rounded p-2 text-sm focus:border-[#E6C299] outline-none font-mono" 
                                                />
                                                <p className="mt-1 text-[9px] text-pe-muted">Kalendermonat für Start/Verlängerung. Wird mit der Basisnummer (MM/JJJJ) synchron gehalten.</p>
                                            </div>
                                            <div>
                                                <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">
                                                    Monatspreis / Fix-Beitrag (€) {stammdatenEdit.isLegacy && <span className="text-blue-400 font-black ml-1">(Vorabkunde)</span>}
                                                </label>
                                                <input 
                                                    type="text" 
                                                    value={stammdatenEdit.monthlyFee} 
                                                    onChange={(e) => setStammdatenEdit({...stammdatenEdit, monthlyFee: e.target.value})} 
                                                    placeholder="0,00"
                                                    disabled={!stammdatenEdit.isLegacy}
                                                    className={`w-full bg-pe-bg border ${stammdatenEdit.isLegacy ? 'border-blue-500/50 text-blue-400' : 'border-pe-border text-pe-muted cursor-not-allowed opacity-70'} rounded p-2 text-sm outline-none font-mono`} 
                                                />
                                                <p className="text-[9px] text-pe-muted mt-1">Dieser Wert wird beim Ändern des Tarifs (Buttons) automatisch live berechnet und eingesetzt.</p>
                                            </div>
                                        </div>
                                        <label className="flex items-start cursor-pointer group mt-4">
                                            <div className="flex items-center h-6">
                                                <input
                                                    type="checkbox"
                                                    checked={!!stammdatenEdit.isLegacy}
                                                    onChange={(e) => setStammdatenEdit({ ...stammdatenEdit, isLegacy: e.target.checked })}
                                                    className="w-5 h-5 rounded border-pe-border-strong text-blue-500 focus:ring-blue-500 bg-pe-bg"
                                                />
                                            </div>
                                            <div className="ml-3">
                                                <span className="text-sm font-bold text-blue-400 group-hover:text-blue-300 transition-colors">Vorabkunde-Status aktiv</span>
                                                <p className="text-[10px] text-pe-muted mt-1">Deaktivieren, um den Vorabkunde-Badge dauerhaft zu entfernen.</p>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="space-y-4 mt-8 pt-8 border-t border-pe-border">
                                        <h3 className="text-sm font-black text-pink-400 uppercase tracking-widest pb-2 flex items-center gap-2">
                                            <HeartIcon size={16} /> Pro Bono (Kostenfreie Betreuung)
                                        </h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <label className="flex items-start cursor-pointer group mt-2">
                                                <div className="flex items-center h-6">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={stammdatenEdit.proBonoActive} 
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setStammdatenEdit({
                                                                ...stammdatenEdit,
                                                                proBonoActive: checked,
                                                                ...(checked ? { monthlyFee: '0,00' } : {}),
                                                            });
                                                        }} 
                                                        className="w-5 h-5 rounded border-pe-border-strong text-pink-500 focus:ring-pink-500 bg-pe-bg" 
                                                    />
                                                </div>
                                                <div className="ml-3">
                                                    <span className="text-sm font-bold text-pink-400 group-hover:text-pink-300 transition-colors">Pro Bono Status aktivieren</span>
                                                    <p className="text-[10px] text-pe-muted mt-1">Die monatliche Abrechnung wird auf 0,00 € gesetzt.</p>
                                                </div>
                                            </label>
                                            
                                            {stammdatenEdit.proBonoActive && (
                                                <div className="animate-fade-in">
                                                    <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Befristet bis (optional)</label>
                                                    <input 
                                                        type="month" 
                                                        value={stammdatenEdit.proBonoUntil} 
                                                        onChange={(e) => setStammdatenEdit({...stammdatenEdit, proBonoUntil: e.target.value})} 
                                                        className="w-full bg-pe-bg border border-pink-500/50 text-pe-text rounded p-2 text-sm focus:border-pink-400 outline-none font-mono" 
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Seltene Notfall-Aktionen — bewusst eingeklappt, nicht in der Tab-Leiste */}
                                    {canAccessAdminPortal && (
                                        <details className="mt-10 mb-28 rounded-lg border border-pe-border bg-pe-bg/40 group">
                                            <summary className="cursor-pointer list-none px-4 py-3 text-[10px] font-bold uppercase tracking-[0.2em] text-pe-muted hover:text-pe-muted transition-colors flex items-center gap-2 select-none">
                                                <span className="text-slate-700 group-open:text-pe-muted">▸</span>
                                                Wartung / Notfall
                                                <span className="normal-case tracking-normal font-normal text-slate-700 ml-1">(nur bei Bedarf)</span>
                                            </summary>
                                            <div className="px-4 pb-4 pt-1 flex flex-col sm:flex-row flex-wrap gap-2 border-t border-pe-border/60">
                                                <button
                                                    type="button"
                                                    onClick={handleForceUnlockDashboard}
                                                    disabled={isProcessingAction}
                                                    className="px-3 py-2 text-[10px] font-bold uppercase tracking-widest rounded-md text-pe-muted border border-pe-border hover:border-emerald-800/60 hover:text-emerald-500/80 transition-colors disabled:opacity-40 text-left"
                                                >
                                                    Dashboard freischalten
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleResetAkteToFreigabe}
                                                    disabled={isProcessingAction}
                                                    className="px-3 py-2 text-[10px] font-bold uppercase tracking-widest rounded-md text-pe-muted border border-pe-border hover:border-orange-800/60 hover:text-orange-500/80 transition-colors disabled:opacity-40 text-left"
                                                >
                                                    Akte in Freigabe-Center zurücksetzen
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleResetMasterPinLock}
                                                    disabled={isProcessingAction}
                                                    className="px-3 py-2 text-[10px] font-bold uppercase tracking-widest rounded-md text-pe-muted border border-pe-border hover:border-amber-800/60 hover:text-amber-500/80 transition-colors disabled:opacity-40 text-left"
                                                >
                                                    Master-PIN & Sperren zurücksetzen
                                                </button>
                                            </div>
                                        </details>
                                    )}

                                    <div className="fixed bottom-0 right-0 w-full max-w-4xl bg-pe-card border-t border-pe-border p-6 flex justify-end gap-4 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
                                        <button type="button" onClick={(e) => {e.preventDefault(); setSelectedAkte(null)}} className="px-6 py-3 bg-pe-card hover:bg-pe-hover text-pe-text rounded-lg font-bold text-sm transition-colors">Abbrechen</button>
                                        <button 
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                saveStammdaten();
                                            }} 
                                            disabled={drawerIsSaving}
                                            className={`px-8 py-3 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg font-black uppercase tracking-widest text-sm transition-all shadow-[0_0_15px_rgba(16,185,129,0.3)] ${drawerIsSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        >
                                            {drawerIsSaving ? 'Speichert...' : 'Stammdaten Speichern'}
                                        </button>
                                    </div>
                                </div>
                            )}

                            {drawerTab === 'termine' && selectedAkte?.id && (
                                <div className="animate-fade-in pb-24">
                                    <CoachingTerminePanel
                                        clientId={selectedAkte.id}
                                        clientLabel={
                                            selectedAkte.firmenname ||
                                            [selectedAkte.vorname, selectedAkte.nachname].filter(Boolean).join(' ') ||
                                            selectedAkte.id
                                        }
                                        defaultCoach={resolveClientCoach(selectedAkte, coachLookupPool)}
                                        coachOptions={assignableTeam}
                                        showNotification={showNotification}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
            
            {showEmergencyModal && (
                <div className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
                    <div className="bg-pe-card border border-red-500/50 rounded-2xl p-8 max-w-md w-full shadow-[0_0_50px_rgba(220,38,38,0.3)] animate-fade-in relative">
                        <button onClick={() => setShowEmergencyModal(false)} className="absolute top-4 right-4 text-pe-muted hover:text-pe-text"><XIcon size={20}/></button>
                        <div className="flex flex-col items-center text-center mb-6">
                            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4">
                                <AlertTriangleIcon size={32} className="text-red-500" />
                            </div>
                            <h2 className="text-xl font-black text-pe-text tracking-widest uppercase mb-2">Notfall-Protokoll</h2>
                            <p className="text-xs text-pe-muted leading-relaxed">
                                Master-Key eingeben. Danach wählen: Martina zum Super-Admin machen
                                <span className="text-pe-muted"> oder </span>
                                wieder zurücksetzen, wenn du wieder einsatzbereit bist.
                            </p>
                        </div>
                        <div className="space-y-4">
                            <input type="password" value={emergencyCode} onChange={(e) => setEmergencyCode(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleEmergencyUnlock('promote')} placeholder="Master-Key eingeben..." className="w-full bg-pe-bg border border-red-500/30 text-pe-text rounded-lg px-4 py-3 text-center tracking-widest font-mono focus:border-red-500 outline-none" autoFocus />
                            {emergencyError && <p className="text-red-500 text-xs text-center font-bold animate-pulse">ZUGRIFF VERWEIGERT.</p>}
                            <button onClick={() => handleEmergencyUnlock('promote')} disabled={isPromoting} className={`w-full ${isPromoting ? 'bg-red-800' : 'bg-red-600 hover:bg-red-500'} text-white font-black tracking-widest uppercase py-3 rounded-lg transition-colors`}>
                                {isPromoting ? 'Bitte warten…' : 'Martina → Super-Admin'}
                            </button>
                            <button onClick={() => handleEmergencyUnlock('revert')} disabled={isPromoting} className="w-full bg-pe-card hover:bg-pe-hover text-pe-text border border-pe-border-strong font-black tracking-widest uppercase py-3 rounded-lg transition-colors disabled:opacity-50">
                                Zurücksetzen (Martina → Admin)
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {toast && (
                <div className={`fixed top-32 left-1/2 transform -translate-x-1/2 z-[100000] px-6 py-3 rounded-full shadow-2xl font-bold text-sm text-white animate-fade-in ${toast.type === 'success' ? 'bg-emerald-600/90 border border-emerald-400' : 'bg-red-600/90 border border-red-400'}`}>
                    {toast.msg}
                </div>
            )}

            <header className="w-full border-b border-pe-border bg-pe-elevated sticky top-0 z-40 shadow-[0_4px_20px_rgba(0,0,0,0.5)]">
                <div className="max-w-[1600px] mx-auto px-4 md:px-8 h-auto md:h-28 py-3 md:py-0 flex items-center justify-between gap-4">
                    {/* Links: Logo + Titel (+ Hamburger nur mobil) */}
                    <div className="flex items-center gap-3 md:gap-6 min-w-0 flex-1 md:flex-none">
                        <img src={PE_LOGO_SRC} alt="PreisExpert Logo" className="h-20 md:h-36 w-auto object-contain relative -my-2 md:-my-5 flex-shrink-0" />
                        <div className="flex flex-col justify-center items-start border-l border-pe-border-strong pl-4 md:pl-6 h-10 md:h-12 min-w-0">
                            <div className="text-[10px] font-black tracking-[0.3em] uppercase text-pe-muted mb-1">PreisExpert</div>
                            <span className="text-pe-accent-text font-black tracking-widest uppercase text-base md:text-xl leading-none truncate">Kommandozentrale</span>
                        </div>
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="md:hidden ml-auto flex-shrink-0 p-2 rounded-lg border border-pe-border-strong bg-pe-card text-pe-accent-text hover:bg-pe-hover transition-colors"
                            aria-label="Menü öffnen/schließen"
                        >
                            {isMobileMenuOpen ? <XLucideIcon size={22} /> : <MenuLucideIcon size={22} />}
                        </button>
                    </div>

                    {/* Rechts Desktop: eine Zeile, kein Umbruch */}
                    <div className="hidden md:flex items-center gap-3 lg:gap-5 flex-nowrap shrink-0">
                        <button 
                            onClick={() => navigate('/coach')} 
                            className="flex items-center gap-2 px-3 lg:px-4 py-2 bg-[#E6C299]/10 hover:bg-[#E6C299]/20 text-pe-accent-text rounded-lg text-xs font-bold tracking-wider transition-colors border border-[#E6C299]/30 whitespace-nowrap"
                        >
                            <ActivityIcon size={16} /> MEIN COACH-PORTAL
                        </button>
                        
                        <ProductivityDock showNotification={showNotification} syncStatus="idle" isAdminView={true} />
                        <div className="w-px h-12 bg-pe-card flex-shrink-0"></div>
                        <button onClick={handleLogout} className="flex items-center gap-2 px-4 lg:px-6 py-2.5 bg-red-600 hover:bg-red-500 rounded-lg text-xs font-black tracking-widest transition-all text-white border border-red-500 whitespace-nowrap">
                            <LogOutIcon size={16} /> VERLASSEN
                        </button>
                    </div>
                </div>

                {/* Mobil: Dock immer sichtbar (nicht nur im Hamburger versteckt) */}
                <div className="md:hidden px-3 pb-3 border-t border-pe-border">
                    <ProductivityDock showNotification={showNotification} syncStatus="idle" isAdminView={true} />
                </div>

                {/* MOBILE-REFORM: Einklappbares Navigations-Panel (Spiegel der Desktop-Sidebar), nur < 768px */}
                {isMobileMenuOpen && (
                    <div className="md:hidden border-t border-pe-border px-4 py-4 space-y-1 animate-fade-in bg-pe-elevated max-h-[min(70vh,32rem)] overflow-y-auto overscroll-contain">
                        <button onClick={() => { setActiveTab('freigabe'); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'freigabe' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <ShieldAlertIcon size={18} className={activeTab === 'freigabe' ? 'text-pe-accent-text' : ''} /> Freigabe-Center
                            {safeApprovals.length > 0 && (
                                <span className="ml-auto min-w-[1.25rem] h-5 px-1.5 rounded-full bg-orange-500 text-black text-[10px] font-black flex items-center justify-center">
                                    {safeApprovals.length}
                                </span>
                            )}
                        </button>
                        <button onClick={() => { setActiveTab('crm'); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'crm' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <UsersIcon size={18} className={activeTab === 'crm' ? 'text-pe-accent-text' : ''} /> Mandanten (CRM)
                        </button>
                        <button onClick={() => { setShowIntakeHub(true); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${openIntakeCount ? 'bg-red-600 text-white border-red-500 hover:bg-red-500' : pendingAdoptionCount ? 'bg-amber-950/50 text-amber-200 border-amber-500/50 hover:bg-amber-900/40' : 'text-pe-accent-text hover:bg-pe-hover border-[#E6C299]/40'}`}>
                            <UsersIcon size={18} className={openIntakeCount ? 'text-pe-text' : pendingAdoptionCount ? 'text-amber-300' : 'text-pe-accent-text'} /> Neukunden
                            <span className="ml-auto flex items-center gap-1.5">
                              <IntakePendingAdoptionPill count={pendingAdoptionCount} />
                              <IntakeCountPill count={openIntakeCount} />
                            </span>
                        </button>
                        <button onClick={() => { setActiveTab('archiv'); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'archiv' ? 'bg-red-900/20 text-red-400 border-red-800/50' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <ArchiveIcon size={18} className={activeTab === 'archiv' ? 'text-red-400' : ''} /> Archiv (Gekündigt)
                        </button>
                        <button onClick={() => { setActiveTab('parameter'); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'parameter' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <SettingsIcon size={18} className={activeTab === 'parameter' ? 'text-pe-accent-text' : ''} /> Globale Parameter
                        </button>
                        <button onClick={() => { setActiveTab('team'); setIsMobileMenuOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'team' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <ShieldCheckIcon size={18} className={activeTab === 'team' ? 'text-pe-accent-text' : ''} /> Rollen & Rechte
                        </button>

                        <div className="my-3 border-t border-pe-border"></div>

                        <button onClick={() => { setShowInvoiceModal(true); setIsMobileMenuOpen(false); }} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text">
                            <FileTextIcon size={18} /> Rechnungs-Creator
                            {pendingSeminarRegsCount > 0 && (
                                <span className="ml-auto min-w-[1.25rem] h-5 px-1.5 rounded-full bg-orange-500 text-black text-[10px] font-black flex items-center justify-center animate-pulse">
                                    {pendingSeminarRegsCount}
                                </span>
                            )}
                        </button>
                        <button onClick={() => { setShowNewsletterModal(true); setIsMobileMenuOpen(false); }} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text">
                            <MailIcon size={18} /> Newsletter & Mailings
                        </button>
                        <button onClick={() => { setShowEventModal(true); setIsMobileMenuOpen(false); }} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text">
                            <CalendarIcon size={18} /> Event-Manager
                        </button>
                        <button onClick={() => { setShowEmergencyModal(true); setIsMobileMenuOpen(false); }} className="w-full flex items-center gap-3 px-4 py-3 text-pe-muted hover:text-red-500 hover:bg-red-900/10 rounded-lg transition-colors font-medium">
                            <KeyIcon size={18} /> Notfall-Zugang
                        </button>

                        <div className="px-4 py-2">
                            <GlobalBackupManager showNotification={showNotification} variant="button" />
                        </div>

                        <div className="my-3 border-t border-pe-border"></div>

                        <button
                            onClick={() => navigate('/coach')}
                            className="w-full flex items-center justify-between px-4 py-3 bg-[#E6C299]/10 hover:bg-[#E6C299]/20 text-pe-accent-text rounded-lg border border-[#E6C299]/30 transition-colors font-bold"
                        >
                            <div className="flex items-center gap-3">
                                <ActivityIcon size={18} /> Mein Coach-Portal
                            </div>
                            <ExternalLinkIcon size={14} />
                        </button>

                        {canAccessAdminPortal && (
                            <>
                                <div className="my-3 border-t border-pe-border"></div>
                                <div className="rounded-lg border border-pe-border-strong/60 bg-pe-card p-3 space-y-2">
                                    <p className={`text-xs font-bold ${pushActive ? 'text-emerald-400' : 'text-pe-text'}`}>
                                        {pushLabel}
                                    </p>
                                    {pushDetail ? (
                                        <p className="text-[10px] text-pe-muted leading-tight">{pushDetail}</p>
                                    ) : null}
                                    <button
                                        type="button"
                                        onClick={handleActivatePush}
                                        disabled={pushBusy || pushLabel.includes('nicht verfügbar') || pushLabel.includes('blockiert')}
                                        className={`w-full py-2.5 rounded-lg text-xs font-bold transition-all border flex items-center justify-center gap-2 ${
                                            pushActive
                                                ? 'bg-emerald-900/30 hover:bg-emerald-700 text-emerald-300 border-emerald-700/50'
                                                : 'bg-blue-900/30 hover:bg-blue-600 text-blue-400 hover:text-pe-text border-blue-900/50'
                                        } disabled:opacity-50 disabled:cursor-not-allowed`}
                                    >
                                        {pushBusy ? 'Registriere…' : pushButtonText}
                                    </button>
                                    <p className="text-[9px] text-pe-muted text-center leading-tight">
                                        Presence-Alert nur für Admins. iOS: erst Home-Bildschirm, dann hier aktivieren.
                                    </p>
                                </div>
                            </>
                        )}

                        <div className="pt-2 border-t border-pe-border">
                            <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-red-600 hover:bg-red-500 rounded-lg text-xs font-black tracking-widest transition-all text-white border border-red-500">
                                <LogOutIcon size={16} /> VERLASSEN
                            </button>
                        </div>
                    </div>
                )}
            </header>

            <div className="flex-1 flex max-w-[1600px] w-full mx-auto p-4 md:p-8 gap-8">
                <aside className="w-64 flex-shrink-0 hidden md:flex md:flex-col h-[calc(100vh-10rem)] sticky top-36">
                    <div className="space-y-2 flex-1 overflow-y-auto pr-2 custom-scrollbar">
                        <button onClick={() => setActiveTab('freigabe')} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'freigabe' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <ShieldAlertIcon size={20} className={activeTab === 'freigabe' ? 'text-pe-accent-text' : ''} /> Freigabe-Center
                            {safeApprovals.length > 0 && (
                                <span className="ml-auto min-w-[1.25rem] h-5 px-1.5 rounded-full bg-orange-500 text-black text-[10px] font-black flex items-center justify-center">
                                    {safeApprovals.length}
                                </span>
                            )}
                        </button>
                        <button onClick={() => setActiveTab('crm')} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'crm' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <UsersIcon size={20} className={activeTab === 'crm' ? 'text-pe-accent-text' : ''} /> Mandanten (CRM)
                        </button>
                        <button onClick={() => setShowIntakeHub(true)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${openIntakeCount ? 'bg-red-600 text-white border-red-500 hover:bg-red-500' : pendingAdoptionCount ? 'bg-amber-950/50 text-amber-200 border-amber-500/50 hover:bg-amber-900/40' : 'text-pe-accent-text hover:bg-pe-hover border-[#E6C299]/40'}`}>
                            <UsersIcon size={20} className={openIntakeCount ? 'text-pe-text' : pendingAdoptionCount ? 'text-amber-300' : 'text-pe-accent-text'} /> Neukunden
                            <span className="ml-auto flex items-center gap-1.5">
                              <IntakePendingAdoptionPill count={pendingAdoptionCount} />
                              <IntakeCountPill count={openIntakeCount} />
                            </span>
                        </button>
                        
                        <button onClick={() => setActiveTab('archiv')} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'archiv' ? 'bg-red-900/20 text-red-400 border-red-800/50' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <ArchiveIcon size={20} className={activeTab === 'archiv' ? 'text-red-400' : ''} /> Archiv (Gekündigt)
                        </button>

                        <div className="my-4 border-t border-pe-border"></div>
                        
                        <button onClick={() => setActiveTab('parameter')} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg border font-medium transition-colors ${activeTab === 'parameter' ? 'bg-pe-card text-pe-text border-pe-border-strong' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent'}`}>
                            <SettingsIcon size={20} className={activeTab === 'parameter' ? 'text-pe-accent-text' : ''} /> Globale Parameter
                        </button>

                        <div className="pt-2">
                            <button 
                                onClick={() => setToolsOpen(!toolsOpen)} 
                                className="w-full flex items-center justify-between px-4 py-3 rounded-lg border font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent"
                            >
                                <div className="flex items-center gap-3">
                                    <LayersIcon size={20} /> Marketing & Tools
                                    {pendingSeminarRegsCount > 0 && (
                                        <span className="min-w-[1.25rem] h-5 px-1.5 rounded-full bg-orange-500 text-black text-[10px] font-black flex items-center justify-center animate-pulse">
                                            {pendingSeminarRegsCount}
                                        </span>
                                    )}
                                </div>
                                {toolsOpen ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
                            </button>
                            
                            {toolsOpen && (
                                <div className="pl-4 mt-2 space-y-1 animate-fade-in border-l-2 border-pe-border ml-6">
                                    <button onClick={() => setShowInvoiceModal(true)} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text text-sm">
                                        <FileTextIcon size={16} /> Rechnungs-Creator
                                        {pendingSeminarRegsCount > 0 && (
                                            <span className="ml-auto min-w-[1.25rem] h-5 px-1.5 rounded-full bg-orange-500 text-black text-[10px] font-black flex items-center justify-center animate-pulse">
                                                {pendingSeminarRegsCount}
                                            </span>
                                        )}
                                    </button>
                                    <button onClick={() => setShowNewsletterModal(true)} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text text-sm">
                                        <MailIcon size={16} /> Newsletter & Mailings
                                    </button>
                                    <button onClick={() => setShowEventModal(true)} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text text-sm">
                                        <CalendarIcon size={16} /> Event-Manager
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="pt-2">
                            <button 
                                onClick={() => setSecurityOpen(!securityOpen)} 
                                className="w-full flex items-center justify-between px-4 py-3 rounded-lg border font-medium transition-colors text-pe-muted hover:bg-pe-hover hover:text-pe-text border-transparent"
                            >
                                <div className="flex items-center gap-3"><LockIcon size={20} /> Admin & Sicherheit</div>
                                {securityOpen ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
                            </button>
                            
                            {securityOpen && (
                                <div className="pl-4 mt-2 space-y-1 animate-fade-in border-l-2 border-pe-border ml-6 pb-2">
                                    <button onClick={() => setActiveTab('team')} className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg font-medium transition-colors text-sm ${activeTab === 'team' ? 'bg-pe-card text-pe-text' : 'text-pe-muted hover:bg-pe-hover hover:text-pe-text'}`}>
                                        <ShieldCheckIcon size={16} className={activeTab === 'team' ? 'text-pe-accent-text' : ''} /> Rollen & Rechte
                                    </button>
                                    
                                    <button onClick={() => setShowEmergencyModal(true)} className="w-full flex items-center gap-3 px-4 py-2.5 text-pe-muted hover:text-red-500 hover:bg-red-900/10 rounded-lg text-sm transition-colors">
                                        <KeyIcon size={16} /> Notfall-Zugang
                                    </button>
                                    
                                    <div className="px-4 py-2.5">
                                        <GlobalBackupManager showNotification={showNotification} variant="button" />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="mt-6 pt-6 border-t border-pe-border">
                            <button 
                                onClick={() => navigate('/coach')} 
                                className="w-full flex items-center justify-between px-4 py-3 bg-pe-hover hover:bg-pe-hover text-pe-muted rounded-lg border border-pe-border-strong/50 hover:border-pe-border-strong transition-all group"
                            >
                                <div className="flex items-center gap-3">
                                    <ActivityIcon size={18} className="text-pe-accent-text" />
                                    <span className="text-sm font-bold">Coach-Portal</span>
                                </div>
                                <ExternalLinkIcon size={14} className="text-pe-muted group-hover:text-pe-text" />
                            </button>
                        </div>
                    </div>
                    
                    <div className="mt-4 pt-4 border-t border-pe-border flex-shrink-0 space-y-3">
                        <SentinelRadar />
                        <StripeRadar />
                        <StealthSepaRadar />
                        <AktivCounterRadar />
                        <ChangeRadarBadge isAdmin />
                    </div>
                </aside>

                <main className="flex-1 min-w-0">
                    {showMissingTopicReminder && (
                        <div className="mb-6 bg-amber-950/40 border border-amber-500/40 rounded-xl p-4 flex items-start gap-3 print:hidden">
                            <AlertTriangleIcon size={18} className="text-amber-400 flex-shrink-0 mt-0.5" />
                            <div>
                                <p className="text-sm font-bold text-amber-300">Noch kein Monats-Thema hinterlegt</p>
                                <p className="text-[11px] text-amber-200/70 mt-1 leading-relaxed">
                                    Mindestens ein Event steht in den nächsten 10 Tagen an, hat aber noch kein Thema.
                                    Bitte Monatsinhalt einpflegen, sonst bleibt die Events-Seite ohne Themenblock.
                                </p>
                            </div>
                        </div>
                    )}

                    {activeTab === 'freigabe' && (
                        <div className="animate-fade-in">
                            <div className="mb-8 flex justify-between items-end">
                                <div>
                                    <h1 className="text-3xl font-bold text-pe-text tracking-tight mb-2">Freigabe-Center</h1>
                                    <p className="text-pe-muted">Übersicht neuer Bewerber im PreisExpert System (Warteschlange).</p>
                                </div>
                                <div className="text-xs font-bold text-pe-muted bg-pe-card px-3 py-1 rounded border border-pe-border-strong">
                                    Wartend: {safeApprovals.length}
                                </div>
                            </div>
                            
                            {error && <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-lg mb-6">{error}</div>}
                            
                            <div className="bg-pe-card rounded-xl border border-pe-border shadow-xl overflow-hidden">
                                {isLoadingPending ? (
                                    <div className="p-8 text-center text-pe-muted animate-pulse font-bold uppercase tracking-widest">Lade Daten...</div>
                                ) : safeApprovals.length === 0 ? (
                                    <div className="p-12 flex flex-col items-center justify-center text-pe-muted">
                                        <div className="font-bold uppercase tracking-widest">Keine Bewerber in der Warteschlange.</div>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto w-full">
                                    <table className="w-full min-w-[860px] text-left border-collapse">
                                        <thead>
                                            <tr className="bg-pe-tile-header border-b border-pe-border text-[10px] uppercase tracking-wider text-pe-muted">
                                                <th className="p-4 font-black">Firma / Bewerber</th>
                                                <th className="p-4 font-black">E-Mail</th>
                                                <th className="p-4 font-black text-right">Zuweisung & Aktion</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-pe-border">
                                            {safeApprovals.map((client: PendingClient) => {
                                                return (
                                                    <tr key={client.id} className="hover:bg-pe-hover transition-colors group">
                                                        <td className="p-4">
                                                            <div className="font-bold text-pe-text text-sm flex items-center gap-2">
                                                                {client.firmenname || 'Kein Name'}
                                                                {client.isLegacy && (
                                                                    <span className="bg-blue-100 text-blue-900 border border-blue-400 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/30 px-1.5 py-0.5 rounded text-[8px] uppercase tracking-widest font-black shrink-0">Vorabkunde</span>
                                                                )}
                                                            </div>
                                                            <div className="text-[10px] text-pe-muted uppercase font-medium mt-1">{client.vorname} {client.nachname}</div>
                                                        </td>
                                                        <td className="p-4 text-pe-muted text-xs font-mono">{client.email || 'Keine E-Mail'}</td>
                                                        <td className="p-4 text-right">
                                                            <div className="flex items-center justify-end gap-3">
                                                                <select 
                                                                    className="bg-pe-bg border border-pe-border-strong text-pe-accent-text rounded px-3 py-1.5 text-xs font-bold outline-none focus:border-[#E6C299] transition-colors cursor-pointer"
                                                                    defaultValue=""
                                                                    onChange={(e) => {
                                                                        if (e.target.value) {
                                                                            handleCoachChange(client.id, e.target.value);
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="" disabled>+ Coach zuweisen</option>
                                                                    {assignableTeam.map(coach => (
                                                                        <option key={coach.id} value={coach.id}>{coach.name}</option>
                                                                    ))}
                                                                </select>
                                                                <div className="w-px h-6 bg-pe-card"></div>
                                                                <button onClick={() => handleArchive(client.id)} disabled={isProcessingAction} className="inline-flex items-center justify-center p-2 bg-pe-card text-red-400 border border-pe-border-strong rounded hover:bg-red-900/30 hover:border-red-500/50 transition-colors shadow-lg" title="Akte sofort archivieren">
                                                                    <ArchiveIcon size={16} />
                                                                </button>
                                                                <button onClick={() => openAkte(client)} className="inline-flex items-center gap-2 px-4 py-2 bg-pe-card text-pe-muted border border-pe-border-strong rounded text-[10px] font-black uppercase hover:bg-pe-hover transition-colors shadow-lg">
                                                                    <ExternalLinkIcon size={14} /> Akte prüfen
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {activeTab === 'crm' && (
                        <div className="animate-fade-in">
                            <CoachSeminarOverview />
                            <div className="mb-8 flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
                                <div>
                                    <h1 className="text-3xl font-bold text-pe-text tracking-tight mb-2 flex items-center gap-4">
                                        Mandanten (CRM)
                                    </h1>
                                    <p className="text-pe-muted">Verwaltung der aktiven Mandanten, Zahlungen und Finanz-Akten.</p>
                                </div>
                                <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto mt-4 md:mt-0">
                                    <button 
                                        onClick={() => setShowVorabModal(true)}
                                        className="w-full md:w-auto flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded text-xs font-bold uppercase tracking-widest transition-colors shadow-lg"
                                    >
                                        <PlusIcon size={16} /> Neuer Vorabkunde
                                    </button>
                                    <div className="relative w-full md:w-64">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon size={14} className="text-pe-muted" />
                                        </div>
                                        <input 
                                            type="text" 
                                            placeholder="Name oder Mandant-Nr..." 
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="w-full pl-9 pr-4 py-2 bg-pe-input border border-pe-border-strong rounded text-sm text-pe-text focus:border-[#E6C299] outline-none transition-colors placeholder:text-pe-muted"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => setShowOnlyMine((v) => !v)}
                                        className={`w-full md:w-auto px-4 py-2 rounded border text-xs font-bold uppercase tracking-widest transition-all ${showOnlyMine ? 'bg-[#E6C299]/10 border-[#E6C299] text-pe-accent-text' : 'bg-pe-input border-pe-border-strong text-pe-muted hover:text-pe-text'}`}
                                    >
                                        Nur meine
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setShowInactive((v) => !v)}
                                        className={`w-full md:w-auto px-4 py-2 rounded border text-xs font-bold uppercase tracking-widest transition-all ${showInactive ? 'bg-amber-100 border-amber-500 text-amber-950 dark:bg-amber-500/15 dark:border-amber-500/60 dark:text-amber-300' : 'bg-pe-input border-pe-border-strong text-pe-muted hover:text-pe-text'}`}
                                    >
                                        Nicht aktiv
                                    </button>
                                    <div className="text-xs font-bold text-pe-accent-text bg-[#E6C299]/10 px-3 py-2 rounded border border-[#E6C299]/30 whitespace-nowrap">
                                        {showInactive ? 'Datenerfassung' : 'Aktiv'}: {filteredCrmClients.length}
                                    </div>
                                </div>
                            </div>
                            
                            {error && <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-lg mb-6">{error}</div>}
                            
                            <div className="bg-pe-card rounded-xl border border-pe-border shadow-xl overflow-hidden">
                                {isLoadingPending ? (
                                    <div className="p-8 text-center text-pe-muted animate-pulse font-bold uppercase tracking-widest">Lade CRM Daten...</div>
                                ) : filteredCrmClients.length === 0 ? (
                                    <div className="p-12 flex flex-col items-center justify-center text-pe-muted">
                                        <div className="font-bold uppercase tracking-widest">Keine passenden Mandanten gefunden.</div>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto w-full">
                                    <table className="w-full min-w-[860px] text-left border-collapse">
                                        <thead>
                                            <tr className="bg-pe-tile-header border-b border-pe-border text-[10px] uppercase tracking-wider text-pe-muted">
                                                <th className="p-4 font-black">Mandant & Kontakt</th>
                                                <th className="p-4 font-black">System-ID & Betreuer</th>
                                                <th className="p-4 font-black">Status & Stripe</th>
                                                <th className="p-4 font-black text-right sticky right-0 z-20 bg-pe-elevated border-l border-pe-border min-w-[148px] shadow-[-10px_0_16px_rgba(0,0,0,0.35)]">Aktion</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-pe-border">
                                            {filteredCrmClients.map((client: PendingClient) => {
                                                const coach = resolveClientCoach(client, coachLookupPool);
                                                
                                                const years = client.geschaeftsjahre || [];
                                                const latestStatus = years.length > 0 ? years[years.length - 1].status : 'datenerfassung';
                                                
                                                const stripeBadge = resolveStripeBillingBadge(client, {
                                                    latestYearStatus: latestStatus,
                                                });
                                                const stripeDisplay = stripeBadge.kind === 'pro_bono' ? null : stripeBadge.display;
                                                const stripeColor = stripeBadge.className;
                                                
                                                const isDeathRow = !!client.kuendigungsDatum;
                                                const cancelDateObj = isDeathRow ? new Date(client.kuendigungsDatum!) : null;

                                                const vertragsbeginnRaw =
                                                    resolveVertragsbeginnDisplay(client) ||
                                                    (typeof client.vertragsbeginn === 'string' &&
                                                    /^\d{2}\/\d{4}$/.test(client.vertragsbeginn.trim())
                                                        ? client.vertragsbeginn.trim()
                                                        : null) ||
                                                    (typeof client.clientData?.vertragsbeginn === 'string' &&
                                                    /^\d{2}\/\d{4}$/.test(String(client.clientData.vertragsbeginn).trim())
                                                        ? String(client.clientData.vertragsbeginn).trim()
                                                        : null);
                                                let laufzeitText = "Laufzeit: Startdatum fehlt";
                                                
                                                if (vertragsbeginnRaw && vertragsbeginnRaw.includes('/')) {
                                                    const parts = vertragsbeginnRaw.split('/');
                                                    if (parts.length === 2) {
                                                        const startMonth = parseInt(parts[0], 10);
                                                        const startYear = parseInt(parts[1], 10);
                                                        
                                                        if (!isNaN(startMonth) && !isNaN(startYear) && startMonth >= 1 && startMonth <= 12) {
                                                            const now = new Date();
                                                            const currentMonth = now.getMonth() + 1;
                                                            const currentYear = now.getFullYear();
                                                            
                                                            let nextRenewalYear = currentYear;
                                                            if (currentMonth >= startMonth) {
                                                                nextRenewalYear++;
                                                            }
                                                            if (startYear >= nextRenewalYear) {
                                                                nextRenewalYear = startYear + 1;
                                                            }
                                                            
                                                            const paddedMonth = startMonth.toString().padStart(2, '0');
                                                            laufzeitText = `Start: ${paddedMonth}/${startYear} | Nächste Verlängerung: ${paddedMonth}/${nextRenewalYear}`;
                                                        }
                                                    }
                                                }
                                                
                                                const isProBono = client.proBonoActive || client.clientData?.proBonoActive;
                                                const proBonoUntil = client.proBonoUntil || client.clientData?.proBonoUntil;

                                                const tarifBadge = resolveTarifBadgeDisplay({
                                                    mandantNr: client.mandantNr || client.clientData?.mandantNr,
                                                    client: {
                                                        ...client,
                                                        packageTier: client.packageTier || client.clientData?.packageTier,
                                                        tarifStatus: client.tarifStatus || client.clientData?.tarifStatus,
                                                    },
                                                    settings,
                                                    isLegacy: !!(client.isLegacy || client.clientData?.isLegacy),
                                                    isSolo: typeof client.isSolo === 'boolean' ? client.isSolo : undefined,
                                                    hasEmployeeEval: typeof client.hasEmployeeEval === 'boolean' ? client.hasEmployeeEval : undefined,
                                                    forceSoloTarif: !!(client.forceSoloTarif || client.clientData?.forceSoloTarif),
                                                    lizenzTyp: client.lizenzDetails?.typ || client.clientData?.lizenzDetails?.typ || '',
                                                });

                                                const adminRawNr = String(client.mandantNr || client.clientData?.mandantNr || '').trim();
                                                const adminKdNr = String(client.customerNumber || client.clientData?.customerNumber || '').trim();
                                                const isLegacyRow = !!(client.isLegacy || client.clientData?.isLegacy);
                                                const coachForRow = resolveClientCoach(client, coachLookupPool);
                                                const coachLetter = resolveCoachInitialLetter(
                                                    coachForRow?.name || client.betreuer || client.coachId,
                                                    coachLookupPool
                                                );
                                                const looksVorab =
                                                    isLegacyRow ||
                                                    isVorabOrLegacyMandantNr(adminRawNr) ||
                                                    isVorabOrLegacyMandantNr(adminKdNr) ||
                                                    /^MA\s+\d{1,2}\s*[./-]\s*\d{4}/i.test(adminRawNr) ||
                                                    /^MA\s+\d{1,2}\s*[./-]\s*\d{4}/i.test(adminKdNr);
                                                // Immer live normalisieren — auch wenn Firestore/Cache noch Altformat hat
                                                const adminSystemNr =
                                                    adminRawNr && adminRawNr !== 'WIEDERHERGESTELLT' && adminRawNr !== '---'
                                                        ? (looksVorab
                                                            ? (normalizeVorabMandantNr(adminRawNr, coachLetter) ||
                                                               formatMandantNrDisplay(adminRawNr, coachLetter) ||
                                                               adminRawNr)
                                                            : (formatMandantNrDisplay(adminRawNr, coachLetter) || adminRawNr))
                                                        : '';
                                                const adminKdClean =
                                                    adminKdNr && adminKdNr !== 'PENDING'
                                                        ? (looksVorab
                                                            ? (normalizeVorabMandantNr(adminKdNr, coachLetter) ||
                                                               formatMandantNrDisplay(adminKdNr, coachLetter) ||
                                                               adminKdNr)
                                                            : (formatMandantNrDisplay(adminKdNr, coachLetter) || adminKdNr))
                                                        : '';
                                                // Vorab: System-ID (normalisiert) hat Vorrang vor evtl. noch dreckiger Kd.-Nr.
                                                const adminDisplayNr = looksVorab
                                                    ? (adminSystemNr || adminKdClean || 'System-ID wird gesetzt…')
                                                    : (adminKdClean || adminSystemNr || 'System-ID wird gesetzt…');
                                                const computedFee = isLegacyRow
                                                    ? 0
                                                    : calculateClientMonthlyFee({
                                                    settings,
                                                    client,
                                                    isProBono: client.proBonoActive || client.clientData?.proBonoActive,
                                                });
                                                const fixedFee = isLegacyRow
                                                    ? (client.monthlyFee || client.clientData?.monthlyFee)
                                                    : (computedFee || client.monthlyFee || client.clientData?.monthlyFee);
                                                const hasFixedFee = fixedFee !== undefined && fixedFee !== null;

                                                return (
                                                    <tr key={client.id} className={`transition-colors group ${isDeathRow ? 'bg-orange-900/10 border-l-2 border-l-orange-500 hover:bg-orange-900/20' : 'hover:bg-pe-hover'}`}>
                                                        <td className="p-4">
                                                            <div className="font-bold text-pe-text text-base leading-tight flex items-center gap-2 flex-wrap">
                                                                <span>{client.vorname} {client.nachname}</span>
                                                                {client.isLegacy && (
                                                                    <span className="bg-blue-100 text-blue-900 border border-blue-400 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/30 px-1.5 py-0.5 rounded text-[8px] uppercase tracking-widest font-black shrink-0">Vorabkunde</span>
                                                                )}
                                                                {/* Immer erreichbar: auch wenn Aktion-Spalte bei schmaler Breite abgeschnitten ist */}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => openAkte(client)}
                                                                    className="inline-flex items-center gap-1.5 px-2 py-1 bg-[#E6C299] text-black rounded text-[9px] font-black uppercase tracking-widest hover:bg-white transition-colors shrink-0 lg:hidden"
                                                                    title="Akte öffnen"
                                                                >
                                                                    <ExternalLinkIcon size={12} /> Akte
                                                                </button>
                                                            </div>
                                                            <div className="text-xs text-pe-accent-text font-bold mb-1 uppercase tracking-wide mt-1">
                                                                {client.firmenname || client.clientData?.salonname || 'Keine Firma'}
                                                            </div>
                                                            {isDeathRow && cancelDateObj && (
                                                                <div className="text-[9px] font-black tracking-widest text-orange-400 bg-orange-500/10 border border-orange-500/20 px-2 py-0.5 rounded mt-1 mb-1.5 inline-block">
                                                                    GEKÜNDIGT ZUM: {cancelDateObj.toLocaleDateString('de-DE')}
                                                                </div>
                                                            )}
                                                            <div className="text-[10px] text-pe-muted font-mono flex items-center gap-1.5 mt-1">
                                                                <MailIcon size={10} className="text-pe-muted" /> {client.email || '---'}
                                                            </div>
                                                        </td>
                                                        <td className="p-4">
                                                            <div className="flex flex-wrap items-center gap-2 mb-1">
                                                                {adminDisplayNr.includes('wird gesetzt') ? (
                                                                    <div className="text-sm font-black tracking-widest text-pe-muted bg-pe-card inline-block px-2 py-0.5 rounded border border-pe-border-strong whitespace-nowrap">
                                                                        {adminDisplayNr}
                                                                    </div>
                                                                ) : (
                                                                    <MandantNrPill
                                                                        displayNr={adminDisplayNr}
                                                                        betreuer={coachForRow?.name || client.betreuer || client.coachId}
                                                                        team={coachLookupPool}
                                                                        tarifLabel={tarifBadge?.label}
                                                                        tarifClassName={tarifBadge?.className}
                                                                        size="sm"
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="text-[9px] text-pe-muted font-mono mb-2" title="Firebase Datenbank ID">
                                                                DB-ID: {client.id}
                                                            </div>
                                                            <div className="relative inline-block">
                                                                <select
                                                                    className={`appearance-none bg-pe-bg border ${coach ? 'border-blue-500 text-blue-900 dark:border-blue-800/50 dark:text-blue-400' : 'border-red-500 text-red-800 dark:border-red-800/50 dark:text-red-400'} rounded px-2 py-1 text-[9px] font-bold uppercase tracking-widest outline-none focus:border-[#E6C299] transition-colors cursor-pointer text-center`}
                                                                    value={coach ? coach.id : ""}
                                                                    onChange={(e) => {
                                                                        if (e.target.value) {
                                                                            handleCoachChange(client.id, e.target.value);
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="" disabled>Kein Coach</option>
                                                                    {assignableTeam.map(c => (
                                                                        <option key={c.id} value={c.id}>COACH: {c.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </td>
                                                        <td className="p-4">
                                                            <div className="flex flex-col items-start gap-2">
                                                                {latestStatus === 'datenerfassung' && (
                                                                    <span className="bg-purple-100 text-purple-900 border border-purple-400 dark:bg-purple-500/10 dark:text-purple-400 dark:border-purple-500/20 px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest flex items-center gap-1">
                                                                        <ClockIcon size={10} /> Noch in Erfassung
                                                                    </span>
                                                                )}
                                                                {latestStatus === 'aktiv' && (
                                                                    <span className="bg-emerald-100 text-emerald-900 border border-emerald-400 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20 px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest flex items-center gap-1">
                                                                        <CheckCircleIcon size={10} /> Akte Aktiv
                                                                    </span>
                                                                )}
                                                                {(latestStatus === 'angefragt' || (latestStatus !== 'datenerfassung' && latestStatus !== 'aktiv')) && (
                                                                    <span className="bg-amber-100 text-amber-950 border border-amber-500 dark:bg-yellow-500/10 dark:text-yellow-500 dark:border-yellow-500/20 px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest flex items-center gap-1">
                                                                        <AlertTriangleIcon size={10} /> Übertragen · Prüfung
                                                                    </span>
                                                                )}
                                                                
                                                <span className="bg-pe-card text-pe-text border border-pe-border-strong px-2 py-0.5 rounded text-sm font-black tracking-widest flex items-center gap-1.5 w-max">
                                                                    <CalendarIcon size={12} className="text-pe-text shrink-0" /> {laufzeitText}
                                                                </span>

                                                {(() => {
                                                                    const chronikRaw = client.clientData?.aenderungsChronik || client.aenderungsChronik || [];
                                                                    const seen = new Set<string>();
                                                                    const chronikCount = (Array.isArray(chronikRaw) ? chronikRaw : []).filter((e: any) => {
                                                                        const key = `${e?.createdAt || ''}|${e?.authorName || ''}|${e?.description || ''}|${e?.draftId || ''}|${e?.category || ''}`;
                                                                        if (seen.has(key)) return false;
                                                                        seen.add(key);
                                                                        return true;
                                                                    }).length;
                                                                    if (chronikCount === 0) return null;
                                                                    return (
                                                                        <span
                                                                            className="bg-[#E6C299]/10 text-pe-accent-text border border-[#E6C299]/30 px-2 py-0.5 rounded text-[9px] font-bold uppercase tracking-widest flex items-center gap-1 w-max"
                                                                            title="Einträge in der Änderungszentrale-Chronik"
                                                                        >
                                                                            Chronik: {chronikCount}
                                                                        </span>
                                                                    );
                                                                })()}

                                                                {hasFixedFee && !(client.proBonoActive || client.clientData?.proBonoActive) && (
                                                                    (() => {
                                                                        const netto = Number(fixedFee) || 0;
                                                                        const mwst = getCountryMwstSatz(settings as any);
                                                                        const brutto = netToGross(netto, mwst);
                                                                        return (
                                                                            <div className="flex flex-col gap-0.5 items-start">
                                                                                <span className="bg-pe-card text-pe-muted border border-pe-border-strong px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest w-max">
                                                                                    Netto: {formatEuroDe(netto)} €{isLegacyRow ? ' (Fix)' : ''}
                                                                                </span>
                                                                                <span className="bg-[#E6C299]/15 text-pe-accent-text border border-[#E6C299]/35 px-2 py-1 rounded text-[9px] font-black uppercase tracking-widest w-max">
                                                                                    Brutto: {formatEuroDe(brutto)} € · {mwst} % MwSt
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    })()
                                                                )}

                                                                {isProBono && (
                                                                    <span className="bg-pink-100 text-pink-900 border border-pink-400 dark:bg-pink-500/10 dark:text-pink-400 dark:border-pink-500/20 px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest flex items-center gap-1 w-max">
                                                                        <HeartIcon size={10} /> Pro Bono {proBonoUntil ? `(bis ${proBonoUntil})` : ''}
                                                                    </span>
                                                                )}

                                                                {stripeDisplay && !isProBono && (
                                                                    <span
                                                                        className={`px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest border flex items-center gap-1 w-max ${stripeColor}`}
                                                                        title={
                                                                            stripeBadge.isCritical
                                                                                ? STRIPE_PAYMENT_LOCK_ARMED
                                                                                    ? 'Zahlungsstop — Zugang gesperrt'
                                                                                    : 'Zahlungsstop erkannt — Sperre noch nicht scharfgeschaltet'
                                                                                : stripeBadge.display
                                                                        }
                                                                    >
                                                                        💳 {stripeDisplay}
                                                                        {stripeBadge.isCritical && !STRIPE_PAYMENT_LOCK_ARMED && (
                                                                            <span className="text-[8px] opacity-70 normal-case tracking-normal">(Sperre aus)</span>
                                                                        )}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className={`p-4 text-right sticky right-0 z-10 min-w-[148px] border-l border-pe-border shadow-[-10px_0_16px_rgba(0,0,0,0.3)] ${isDeathRow ? 'bg-orange-950/40' : 'bg-pe-card'} group-hover:bg-pe-hover`}>
                                                            <div className="flex items-center justify-end gap-2 sm:gap-3">
                                                                <button onClick={() => { setCancelClient(client); setShowCancelModal(true); }} className={`inline-flex items-center justify-center p-2 bg-pe-card ${isDeathRow ? 'text-orange-600' : 'text-orange-400'} border border-pe-border-strong rounded hover:bg-orange-900/30 hover:border-orange-500/50 transition-colors shadow-lg shrink-0`} title={isDeathRow ? "Kündigung bearbeiten" : "Kündigung einleiten"}>
                                                                    <ArchiveIcon size={16} />
                                                                </button>
                                                                <button 
                                                                    onClick={() => openAkte(client)} 
                                                                    className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-[#E6C299] text-black rounded text-[10px] font-black uppercase hover:bg-white transition-colors shadow-lg shrink-0"
                                                                >
                                                                    <ExternalLinkIcon size={14} /> <span className="hidden sm:inline">Akte öffnen</span><span className="sm:hidden">Akte</span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {activeTab === 'archiv' && (
                        <div className="animate-fade-in">
                            <div className="mb-8 flex justify-between items-end">
                                <div>
                                    <h1 className="text-3xl font-bold text-red-500 tracking-tight mb-2 flex items-center gap-3">
                                        <ArchiveIcon size={28} /> System-Archiv
                                    </h1>
                                    <p className="text-pe-muted">Gekündigte oder stillgelegte Akten.</p>
                                </div>
                                <div className="text-xs font-bold text-red-400 bg-red-900/20 px-3 py-1 rounded border border-red-800/50">
                                    Archiviert: {archivedClients.length}
                                </div>
                            </div>
                            
                            <div className="bg-pe-card rounded-xl border border-red-900/30 shadow-xl overflow-hidden">
                                {isLoadingPending ? (
                                    <div className="p-8 text-center text-pe-muted animate-pulse font-bold uppercase tracking-widest">Lade Archiv...</div>
                                ) : archivedClients.length === 0 ? (
                                    <div className="p-12 flex flex-col items-center justify-center text-pe-muted">
                                        <ArchiveIcon size={48} className="mb-4 opacity-50" />
                                        <div className="font-bold uppercase tracking-widest">Das Archiv ist leer.</div>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto w-full">
                                    <table className="w-full min-w-[860px] text-left border-collapse">
                                        <thead>
                                            <tr className="bg-red-900/10 border-b border-red-900/30 text-[10px] uppercase tracking-wider text-red-400/70">
                                                <th className="p-4 font-black">Archiv-Akte</th>
                                                <th className="p-4 font-black">ID & Info</th>
                                                <th className="p-4 font-black text-right">Aktionen</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-red-900/20">
                                            {archivedClients.map((client: PendingClient) => (
                                                <tr key={client.id} className="hover:bg-red-900/10 transition-colors group">
                                                    <td className="p-4 opacity-70 group-hover:opacity-100 transition-opacity">
                                                        <div className="font-bold text-pe-text text-base leading-tight flex items-center gap-2">
                                                            {client.vorname} {client.nachname}
                                                            {client.isLegacy && (
                                                                <span className="bg-blue-100 text-blue-900 border border-blue-400 dark:bg-blue-500/10 dark:text-blue-400 dark:border-blue-500/30 px-1.5 py-0.5 rounded text-[8px] uppercase tracking-widest font-black shrink-0">Vorabkunde</span>
                                                            )}
                                                        </div>
                                                        <div className="text-xs text-pe-accent-text font-bold mb-1 uppercase tracking-wide mt-1">
                                                            {client.firmenname || client.clientData?.salonname || 'Keine Firma'}
                                                        </div>
                                                    </td>
                                                    <td className="p-4 opacity-70 group-hover:opacity-100 transition-opacity">
                                                        <div className="text-sm font-black tracking-widest text-pe-muted mb-1 font-mono">
                                                            {client.mandantNr || 'Keine MA-Nr'}
                                                        </div>
                                                        <div className="text-[9px] text-pe-muted font-mono">
                                                            ID: {client.id}
                                                        </div>
                                                    </td>
                                                    <td className="p-4 text-right">
                                                        <div className="flex items-center justify-end gap-3">
                                                            <button 
                                                                onClick={() => openAkte(client)} 
                                                                className="inline-flex items-center gap-2 px-4 py-2 bg-pe-card text-pe-muted border border-pe-border-strong rounded text-[10px] font-black uppercase hover:bg-pe-hover transition-colors shadow-lg"
                                                            >
                                                                <ExternalLinkIcon size={14} /> Akte öffnen (Schreibgeschützt)
                                                            </button>
                                                            <button 
                                                                onClick={() => handleReactivate(client.id)} 
                                                                disabled={isProcessingAction}
                                                                className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-900/30 text-emerald-400 border border-emerald-800/50 rounded text-[10px] font-black uppercase hover:bg-emerald-600 hover:text-white hover:border-emerald-500 transition-colors"
                                                            >
                                                                <CheckCircleIcon size={14} /> Reaktivieren
                                                            </button>
                                                            <button 
                                                                onClick={() => handleHardDelete(client.id, client.firmenname || client.vorname || 'Unbekannt')} 
                                                                disabled={isProcessingAction}
                                                                className="inline-flex items-center gap-2 px-4 py-2 bg-red-900/30 text-red-500 border border-red-800/50 rounded text-[10px] font-black uppercase hover:bg-red-600 hover:text-white hover:border-red-500 transition-colors"
                                                            >
                                                                <TrashIcon size={14} /> Nuke (Löschen)
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {activeTab === 'team' && (
                        <div className="animate-fade-in">
                            <div className="mb-8 flex justify-between items-start">
                                <div>
                                    <h1 className="text-3xl font-bold text-pe-text tracking-tight mb-2 flex items-center gap-3">
                                        Sicherheit & Rollen 
                                        <LockIcon size={24} className="text-red-500" />
                                    </h1>
                                    <p className="text-pe-muted">Hochsicherheitsbereich: Zuweisung von System-Rechten.</p>
                                </div>
                            </div>

                            {isSuperAdminOperator && (
                                <div className="mb-6 bg-pe-card rounded-xl border border-pe-border shadow-xl p-4 flex flex-col md:flex-row md:items-end gap-4">
                                    <div className="flex-1">
                                        <label className="text-[10px] text-pe-muted font-bold uppercase tracking-wider mb-1 block">Rekrutierung (Registry → Aktives Team)</label>
                                        <select
                                            value={recruitCandidateId}
                                            onChange={(e) => setRecruitCandidateId(e.target.value)}
                                            className="w-full bg-pe-bg border border-pe-border-strong text-pe-accent-text rounded px-3 py-2 text-sm font-bold outline-none focus:border-[#E6C299] transition-colors cursor-pointer"
                                        >
                                            <option value="">Person aus Registry wählen…</option>
                                            {recruitableMembers.map((candidate) => (
                                                <option key={candidate.id} value={candidate.id}>
                                                    {candidate.name} ({candidate.id})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button
                                        onClick={handleAuthorizeTeamMember}
                                        disabled={!recruitCandidateId || isTeamActionSaving}
                                        className={`px-5 py-2.5 rounded-lg text-xs font-black uppercase tracking-widest transition-colors ${(!recruitCandidateId || isTeamActionSaving) ? 'bg-pe-card text-pe-muted cursor-not-allowed' : 'bg-[#E6C299] text-black hover:bg-white'}`}
                                    >
                                        {isTeamActionSaving ? 'Speichere…' : '+ Teammitglied autorisieren'}
                                    </button>
                                </div>
                            )}

                            <div className="bg-pe-card rounded-xl border border-pe-border shadow-xl overflow-hidden relative">
                                {safeAdminTeam.length === 0 ? (
                                    <div className="p-12 flex flex-col items-center justify-center text-pe-muted">
                                        <ShieldCheckIcon size={48} className="mb-4 opacity-50" />
                                        <div className="font-bold uppercase tracking-widest">Keine aktiven System-User gefunden.</div>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto w-full">
                                    <table className="w-full min-w-[860px] text-left border-collapse">
                                        <thead>
                                            <tr className="bg-pe-tile-header border-b border-pe-border text-[10px] uppercase tracking-wider text-pe-muted">
                                                <th className="p-4 font-black">System-Operator</th>
                                                <th className="p-4 font-black">Sicherheits-Level</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-pe-border">
                                            {safeAdminTeam.map((member: AdminTeamMember) => {
                                                const isSuperAdminUser = (member.name?.includes('Christian') || member.role === 'superadmin' || member.category === 'superadmin');
                                                const rawRole = member.role || member.category || 'coach';
                                                const currentRole = isSuperAdminUser
                                                    ? 'superadmin'
                                                    : (rawRole === 'admin' || member.category === 'admin' ? 'admin' : (rawRole === 'support' || member.category === 'support' ? 'support' : 'coach'));
                                                
                                                return (
                                                    <tr key={member.id} className="transition-colors group hover:bg-pe-hover">
                                                        <td className="p-4 flex items-center gap-3">
                                                            <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs ${isSuperAdminUser ? 'bg-red-900/50 text-red-500 border border-red-500' : 'bg-pe-card text-pe-muted border border-pe-border-strong'}`}>
                                                                {member.name.charAt(0)}
                                                            </div>
                                                            <div>
                                                                <div className="font-bold text-pe-text text-sm">{member.name}</div>
                                                                <div className="text-[10px] text-pe-muted uppercase font-mono">{member.id}</div>
                                                            </div>
                                                        </td>
                                                        <td className="p-4">
                                                            <div className="flex items-center gap-2 flex-wrap">
                                                                <div className="relative inline-block">
                                                                <select 
                                                                    disabled={isSuperAdminUser}
                                                                    className={`appearance-none bg-pe-bg border ${isSuperAdminUser ? 'border-red-900/30 text-red-500/50 cursor-not-allowed' : 'border-pe-border-strong text-pe-muted'} rounded px-3 py-1.5 pr-8 text-xs font-bold outline-none focus:border-[#E6C299] transition-colors`}
                                                                    value={currentRole === 'superadmin' ? 'admin' : currentRole}
                                                                    onChange={async (e) => {
                                                                        const newRole = e.target.value;
                                                                        try {
                                                                            await updateTeamMemberRole(member.id, newRole);
                                                                            showNotification(`Rolle für ${member.name} gespeichert: ${newRole}`, 'success');
                                                                        } catch {
                                                                            showNotification('Fehler beim Speichern der Rolle in Firebase.', 'error');
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="coach">Coach (Standard)</option>
                                                                    <option value="support">Support</option>
                                                                    <option value="admin">Admin</option>
                                                                </select>
                                                                </div>
                                                                {isSuperAdminOperator && !isSuperAdminUser && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDeauthorizeTeamMember(member.id)}
                                                                        disabled={isTeamActionSaving}
                                                                        className="px-2 py-1.5 rounded text-[10px] font-black uppercase tracking-widest bg-red-950/40 text-red-400 border border-red-800/50 hover:bg-red-900/40 transition-colors disabled:opacity-50"
                                                                    >
                                                                        Entfernen
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {activeTab === 'parameter' && (
                        <div className="animate-fade-in -mt-4">
                            <div className="ui-freeze-active">
                                <KalkulationsdatenPage />
                            </div>
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default AdminDashboard;